/* <olivia-protocol> generated by tools/olivia/sync-protocol.mjs from packages/olivia-protocol; do not edit */
// olivia-protocol@e9b5172, TypeScript stripped by Node v22.21.1
export const OLIVIA_PROTOCOL_VERSION = 2;
export const LOCALES = ["it","en","fr","de"];
export const QTY_MIN = 1;
export const QTY_MAX = 6;
export const CART_LINES_MAX = 3;
export const HISTORY_MAX = 12;
export const THREAD_TURNS_MAX = 30;
export const MESSAGE_MAX = 500;
export const CARDS_PER_RUN_MAX = 2;
export const TOOL_NAMES = ["search_catalog","get_variant_prices","get_shipping_rates","get_lot","get_season_state","search_shop_faqs","propose_cart","redirect_contact"];
export const CARD_KINDS = ["product_plate","price_row","band_row","cart_summary","lot_instrument","link_row","avvisami_field","contact_row","chip_row"];
export const LIMIT_REASONS = ["max_tool_calls","max_same_tool","max_output","wall_clock","adapter_cap","claim_blocked"];
export const RUN_ERROR_CODES = ["RUNTIME_OFF","RUNTIME_UNAVAILABLE","RATE_LIMITED","TURN_BUSY","PROTOCOL_MISMATCH","TIMEOUT","ABORTED","INVALID_INPUT"];
export const GATE_REASONS = ["disabled","switched_off","not_allowlisted","rate_limited","session_cap","auto_paused"];
export const SIGNAL_KINDS = ["cart_added","checkout_clicked","contact_clicked","product_link_clicked"];
export const INTENT_IDS = ["which_oil","which_size","shipping_cost","season_preorder","gift","provenance_lot","storage_use","returns_damage"];
export const SUGGESTIONS_MAX = 3;
export const SUGGESTION_LABEL_MAX = 40;
export const SUGGESTION_SEND_MAX = 200;
export const END_STATES = ["answered","checkout_offered","notify_offered","handoff","limit"];
export const AVAILABILITY = ["available","preorder","sold_out"];
export const PRODUCT_CTAS = ["add_to_cart","view","notify"];
export const CONTACT_REASONS = ["gift_wrap","after_sale","return","damage","account","b2b","order_status","limit","other"];
// src/errors.ts
export class HTTPError extends Error {
    status;
    body;
    constructor(message, status, body){
        super(message), this.status = status, this.body = body;
        this.name = "HTTPError";
    }
}
export class ProtocolParseError extends Error {
    constructor(message){
        super(message);
        this.name = "ProtocolParseError";
    }
}
export class ProtocolVersionError extends Error {
    constructor(message){
        super(message);
        this.name = "ProtocolVersionError";
    }
}
// src/sse.ts
export function parseSSEFrame(raw) {
    let id;
    let event;
    const data = [];
    let sawData = false;
    for (const line of raw.split(/\r?\n/)){
        if (line === "" || line.startsWith(":")) continue;
        const colon = line.indexOf(":");
        const field = colon === -1 ? line : line.slice(0, colon);
        let value = colon === -1 ? "" : line.slice(colon + 1);
        if (value.startsWith(" ")) value = value.slice(1);
        switch(field){
            case "id":
                id = value;
                break;
            case "event":
                event = value;
                break;
            case "data":
                sawData = true;
                data.push(value);
                break;
            default:
                throw new ProtocolParseError(`unknown SSE field: ${field}`);
        }
    }
    if (!sawData) {
        if (id === undefined && event === undefined) return undefined;
        throw new ProtocolParseError("SSE frame without data");
    }
    return id === undefined && event === undefined ? {
        data: data.join("\n")
    } : {
        ...id === undefined ? {} : {
            id
        },
        ...event === undefined ? {} : {
            event
        },
        data: data.join("\n")
    };
}
// src/machine.ts
export const TURN_PHASES = [
    "idle",
    "sending",
    "streaming",
    "done",
    "error",
    "cooldown",
    "off",
    "unavailable",
    "capped"
];
export const TURN_INPUT_KEYS = [
    "RUN_STARTED",
    "TEXT_MESSAGE_START",
    "TEXT_MESSAGE_CONTENT",
    "TEXT_MESSAGE_END",
    "TOOL_CALL_START",
    "TOOL_CALL_END",
    "olivia.card",
    "olivia.limit",
    "olivia.end",
    "olivia.text.retract",
    "RUN_FINISHED",
    "RUN_ERROR",
    "submit",
    "retry",
    "abort",
    "new",
    "timer",
    "http"
];
export const DEFAULT_COOLDOWN_SEC = 30;
export class UnreachableError extends Error {
    value;
    constructor(value){
        super(`unreachable: ${JSON.stringify(value)}`), this.value = value;
        this.name = "UnreachableError";
    }
}
export function assertNever(x) {
    throw new UnreachableError(x);
}
export function turnInputKey(input) {
    if ("kind" in input) {
        switch(input.kind){
            case "submit":
            case "retry":
            case "abort":
            case "new":
            case "timer":
            case "http":
                return input.kind;
            default:
                return assertNever(input);
        }
    }
    switch(input.type){
        case "CUSTOM":
            return input.name;
        case "RUN_STARTED":
        case "TEXT_MESSAGE_START":
        case "TEXT_MESSAGE_CONTENT":
        case "TEXT_MESSAGE_END":
        case "TOOL_CALL_START":
        case "TOOL_CALL_END":
        case "RUN_FINISHED":
        case "RUN_ERROR":
            return input.type;
        default:
            return assertNever(input);
    }
}
export function initialTurn() {
    return {
        phase: "idle",
        text: "",
        cards: [],
        suggestions: [],
        busy: false,
        unknownEvents: 0
    };
}
function fresh(view, phase) {
    return {
        phase,
        text: "",
        cards: [],
        suggestions: [],
        busy: false,
        unknownEvents: view.unknownEvents
    };
}
function unknown(view) {
    return {
        ...view,
        unknownEvents: view.unknownEvents + 1
    };
}
function withoutMessage(view) {
    const next = {
        ...view,
        text: ""
    };
    delete next.messageId;
    return next;
}
export function fromHttp(view, input) {
    if (input.status === 429 && input.reason === "session_cap") return fresh(view, "capped");
    if (input.status === 429) return {
        ...fresh(view, "cooldown"),
        retryAfterSec: input.retryAfterSec ?? DEFAULT_COOLDOWN_SEC
    };
    if (input.status === 403 && input.code === "RUNTIME_OFF") return fresh(view, "off");
    if (input.status >= 500 || input.status > 0 && !input.json) return fresh(view, "unavailable");
    return {
        ...fresh(view, "error"),
        errorCode: input.code ?? `HTTP_${input.status}`
    };
}
function reduceResting(view, input) {
    if (!("kind" in input)) return unknown(view);
    switch(input.kind){
        case "submit":
            return fresh(view, "sending");
        case "new":
            return fresh(view, "idle");
        case "retry":
        case "abort":
        case "timer":
        case "http":
            return unknown(view);
        default:
            return assertNever(input);
    }
}
function reduceSending(view, input) {
    if ("kind" in input) {
        switch(input.kind){
            case "http":
                return fromHttp(view, input);
            case "abort":
                return fresh(view, "idle");
            case "submit":
            case "retry":
            case "new":
            case "timer":
                return unknown(view);
            default:
                return assertNever(input);
        }
    }
    switch(input.type){
        case "RUN_STARTED":
            return {
                ...view,
                phase: "streaming",
                runId: input.runId
            };
        case "TEXT_MESSAGE_START":
        case "TEXT_MESSAGE_CONTENT":
        case "TEXT_MESSAGE_END":
        case "TOOL_CALL_START":
        case "TOOL_CALL_END":
        case "CUSTOM":
        case "RUN_FINISHED":
        case "RUN_ERROR":
            return unknown(view);
        default:
            return assertNever(input);
    }
}
function reduceStreaming(view, input) {
    if ("kind" in input) {
        switch(input.kind){
            case "abort":
                return fresh(view, "idle");
            case "submit":
            case "retry":
            case "new":
            case "timer":
            case "http":
                return unknown(view);
            default:
                return assertNever(input);
        }
    }
    switch(input.type){
        case "RUN_STARTED":
            return unknown(view);
        case "TEXT_MESSAGE_START":
            return {
                ...view,
                messageId: input.messageId,
                text: ""
            };
        case "TEXT_MESSAGE_END":
            return {
                ...view
            };
        case "TEXT_MESSAGE_CONTENT":
            return input.messageId === view.messageId ? {
                ...view,
                text: view.text + input.delta
            } : unknown(view);
        case "TOOL_CALL_START":
            return {
                ...view,
                busy: true
            };
        case "TOOL_CALL_END":
            return {
                ...view,
                busy: false
            };
        case "CUSTOM":
            switch(input.name){
                case "olivia.card":
                    return {
                        ...view,
                        cards: [
                            ...view.cards,
                            input.value
                        ]
                    };
                case "olivia.limit":
                    return {
                        ...view,
                        limitReason: input.value.reason,
                        text: input.value.reason === "claim_blocked" ? "" : view.text
                    };
                case "olivia.end":
                    return {
                        ...view,
                        busy: false,
                        suggestions: input.value.suggestions
                    };
                case "olivia.text.retract":
                    return input.value.messageId === view.messageId ? withoutMessage(view) : unknown(view);
                default:
                    return assertNever(input);
            }
        case "RUN_FINISHED":
            return {
                ...view,
                phase: "done",
                busy: false
            };
        case "RUN_ERROR":
            return {
                ...view,
                phase: "error",
                busy: false,
                errorCode: input.code
            };
        default:
            return assertNever(input);
    }
}
function reduceError(view, input) {
    if (!("kind" in input)) return unknown(view);
    switch(input.kind){
        case "retry":
            return view.errorCode === "PROTOCOL_MISMATCH" ? unknown(view) : fresh(view, "sending");
        case "submit":
            return fresh(view, "sending");
        case "new":
            return fresh(view, "idle");
        case "abort":
        case "timer":
        case "http":
            return unknown(view);
        default:
            return assertNever(input);
    }
}
function reduceCooldown(view, input) {
    if (!("kind" in input)) return unknown(view);
    switch(input.kind){
        case "timer":
            return fresh(view, "idle");
        case "submit":
        case "retry":
        case "abort":
        case "new":
        case "http":
            return unknown(view);
        default:
            return assertNever(input);
    }
}
function reduceCapped(view, input) {
    if (!("kind" in input)) return unknown(view);
    switch(input.kind){
        case "new":
            return fresh(view, "idle");
        case "submit":
        case "retry":
        case "abort":
        case "timer":
        case "http":
            return unknown(view);
        default:
            return assertNever(input);
    }
}
function reduceOff(view) {
    return unknown(view);
}
export function reduceTurn(view, input) {
    switch(view.phase){
        case "idle":
        case "done":
        case "unavailable":
            return reduceResting(view, input);
        case "sending":
            return reduceSending(view, input);
        case "streaming":
            return reduceStreaming(view, input);
        case "error":
            return reduceError(view, input);
        case "cooldown":
            return reduceCooldown(view, input);
        case "capped":
            return reduceCapped(view, input);
        case "off":
            return reduceOff(view);
        default:
            return assertNever(view.phase);
    }
}
/* </olivia-protocol> */

// wire ─────────────────────────────────────────────────────────────────────────────────────
// Hand-written guards with the same verdict as the olivia-protocol zod schemas (spec 4.2-4.4),
// the run request builder, money and href helpers. Field by field: z.object() accepts extra
// keys, .strict() refuses them; .optional() accepts a missing key or undefined; .nullable()
// accepts null but not a missing key. tools/olivia/wire.test.mjs holds every guard to the zod
// verdicts recorded in tools/olivia/fixtures/protocol-fixtures.json. Nothing in this section
// touches the DOM, storage or the network, so Node can import the module.

export const CLIENT_TIMEOUT_MS = 50_000; // wallClockMs 45_000 + 5_000 (spec 7.3); change with OLIVIA_MAX_WALL_CLOCK_MS
// The app proxy routes (contract C2, D13): the one place the theme names them; the markup carries none.
export const ENDPOINTS = Object.freeze({ run: '/apps/olivia/run', thread: '/apps/olivia/thread', signal: '/apps/olivia/signal' });
export const SESSION_ENDPOINT = '/apps/olivia/session';
export const SESSION_HEADER = 'x-olivia-session';
export const THREAD_KEY = 'olivia:thread'; // localStorage {"v":1,"id","expiresAt"} (C6), written only by a voluntary send
export const THREAD_TTL_DAYS = 15; // matches OLIVIA_TRANSCRIPT_DAYS on the host; every send renews it
export const OFF_KEY = 'olivia:off'; // sessionStorage '1' after a 403 RUNTIME_OFF; unavailable is never stored

// The names inside <script type="application/json" data-olivia-strings> in
// snippets/lab-olivia-panel.liquid, in the order the snippet writes them
// (tools/olivia/markup.test.mjs holds the two to the same list).
export const STRING_KEYS = [
  'thinking', 'error', 'retry', 'reload', 'error_cart', 'unavailable', 'cooldown', 'limit',
  'cannot_confirm', 'contact', 'subtotal', 'gap_to_free', 'lot_lookup', 'field', 'close',
  'checkout', 'add_to_cart', 'preorder', 'notify', 'see', 'sold_out', 'available', 'ships_by',
  'per_l', 'free_from', 'free', 'shipping_cost', 'price', 'shipping', 'lot', 'cultivar',
  'milling', 'best_before', 'months_long',
  'resume', 'new_conversation', 'reduce', 'to_bottom', 'reply_ready', 'session_cap', 'panel_label',
  'continue_shopping', 'end_conversation', 'return_answer', 'example_questions', 'example_prefix', 'conversation_expired',
];

const STRICT = true;
const isRecord = (v) => typeof v === 'object' && v !== null && !Array.isArray(v);
const literal = (expected) => (v) => v === expected;
const oneOf = (options) => (v) => typeof v === 'string' && options.includes(v);
const str = (min = 0, max = Infinity) => (v) => typeof v === 'string' && v.length >= min && v.length <= max;
const matches = (re, max = Infinity) => (v) => typeof v === 'string' && v.length <= max && re.test(v);
// z.number().int() in zod 4: finite and inside the safe integer range.
const intIn = (min = -Infinity, max = Infinity) => (v) => Number.isSafeInteger(v) && v >= min && v <= max;
const isPositive = (v) => typeof v === 'number' && Number.isFinite(v) && v > 0;
const optional = (guard) => (v) => v === undefined || guard(v);
const nullable = (guard) => (v) => v === null || guard(v);
const objectOf = (shape, strict = false) => {
  const keys = Object.keys(shape);
  return (v) =>
    isRecord(v) &&
    keys.every((key) => shape[key](v[key])) &&
    (!strict || Object.keys(v).every((key) => Object.hasOwn(shape, key)));
};
const arrayOf = (item, min = 0, max = Infinity) => (v) => {
  if (!Array.isArray(v) || v.length < min || v.length > max) return false;
  for (let i = 0; i < v.length; i += 1) if (!item(v[i])) return false;
  return true;
};

// z.iso.date(): YYYY-MM-DD and a real calendar day (zod encodes the calendar in its regex;
// setUTCFullYear keeps years 0000-0099 literal, which Date.UTC alone would move to 19xx).
const DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const isIsoDate = (v) => {
  const m = typeof v === 'string' ? DATE.exec(v) : null;
  if (!m) return false;
  const [year, month, day] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const d = new Date(Date.UTC(2000, 0, 1));
  d.setUTCFullYear(year, month - 1, day);
  return d.getUTCFullYear() === year && d.getUTCMonth() === month - 1 && d.getUTCDate() === day;
};
// z.iso.datetime() with its defaults: UTC "Z" only, no offset, seconds and fraction optional.
const DATETIME = /^(\d{4}-\d{2}-\d{2})T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?Z$/;
const isIsoDatetime = (v) => {
  const m = typeof v === 'string' ? DATETIME.exec(v) : null;
  return m !== null && isIsoDate(m[1]);
};
// z.string().uuid() in zod 4: RFC 9562 versions 1-8, variant 10xx, plus the nil and max UUIDs.
const UUID =
  /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
// HrefSchema: same-origin relative; withRoot() adds a URL-parser check on top.
const HREF = /^\/(?!\/)/;

// src/money.ts, src/ids.ts
const isMoney = objectOf({ cents: intIn(0), currency: literal('EUR') }, STRICT);
const isVariantId = matches(/^\d+$/);
const isProductHandle = matches(/^[a-z0-9-]+$/, 120);
const isLotCode = matches(/^[A-Z]?\d{6}$/);
const isCountryCode = matches(/^[A-Z]{2}$/);
const isCurrencyCode = matches(/^[A-Z]{3}$/);
const isHref = matches(HREF);

// src/cards.ts
const isPreorderProperties = objectOf(
  { 'Product type': literal('Preorder'), 'Ships by': optional(str()), _preorder: str() },
  STRICT,
);
const CART_LINE = { variantId: isVariantId, qty: intIn(QTY_MIN, QTY_MAX), properties: optional(isPreorderProperties) };
const isCartLine = objectOf(CART_LINE, STRICT);
// CartLineSchema.extend({ title, price }) keeps .strict() in zod 4.
const isSummaryLine = objectOf({ ...CART_LINE, title: str(), price: isMoney }, STRICT);
const cardOf = (type, shape) => objectOf({ type: literal(type), id: str(), ...shape });

const isProductPlateShape = cardOf('product_plate', {
  variantId: isVariantId,
  handle: isProductHandle,
  title: str(),
  variantTitle: str(),
  price: isMoney,
  litres: isPositive,
  availability: oneOf(AVAILABILITY),
  shipsBy: optional(isIsoDate),
  line: optional(isCartLine),
  href: isHref,
  cta: oneOf(PRODUCT_CTAS),
});
// The superRefine of ProductPlate, rule by rule.
const isProductPlate = (c) =>
  isProductPlateShape(c) &&
  !(c.cta === 'add_to_cart' && c.availability === 'sold_out') &&
  !(c.cta === 'add_to_cart' && !c.line) &&
  !(c.availability === 'preorder' && c.line && !c.line.properties) &&
  !(c.cta === 'notify' && c.availability !== 'sold_out');

const CARD_GUARDS = {
  product_plate: isProductPlate,
  price_row: cardOf('price_row', {
    rows: arrayOf(
      objectOf({ label: str(), variantId: optional(isVariantId), price: isMoney, litres: optional(isPositive) }),
      1,
      6,
    ),
    note: optional(str()),
  }),
  band_row: cardOf('band_row', {
    country: isCountryCode,
    bandMaxGrams: nullable(intIn()),
    price: nullable(isMoney),
    freeFrom: nullable(isMoney),
    shipsBy: optional(isIsoDate),
    syncedAt: isIsoDatetime,
    lines: optional(arrayOf(isCartLine, 0, CART_LINES_MAX)),
  }),
  cart_summary: cardOf('cart_summary', {
    lines: arrayOf(isSummaryLine, 1, CART_LINES_MAX),
    subtotal: isMoney,
    shipping: nullable(isMoney),
    freeFrom: nullable(isMoney),
    gapToFree: nullable(isMoney),
    shipsBy: optional(isIsoDate),
  }),
  lot_instrument: cardOf('lot_instrument', {
    lot: nullable(
      objectOf({ code: isLotCode, cultivar: str(), field: str(), milledOn: isIsoDate, bestBefore: isIsoDate }),
    ),
    href: isHref,
  }),
  link_row: cardOf('link_row', {
    links: arrayOf(objectOf({ label: str(), text: optional(str()), href: isHref }), 1, 4),
  }),
  avvisami_field: cardOf('avvisami_field', {
    variantId: isVariantId,
    handle: isProductHandle,
    title: str(),
    variantTitle: str(),
  }),
  contact_row: cardOf('contact_row', { reason: oneOf(CONTACT_REASONS) }),
  chip_row: cardOf('chip_row', {
    options: arrayOf(
      objectOf({ variantId: isVariantId, label: str(), price: isMoney, litres: isPositive, line: isCartLine }),
      2,
      3,
    ),
  }),
};

/** Same verdict as CardSchema.safeParse(value).success. A kind dropped from CARD_KINDS is refused. */
export function isCard(value) {
  return (
    isRecord(value) &&
    CARD_KINDS.includes(value.type) &&
    Object.hasOwn(CARD_GUARDS, value.type) &&
    CARD_GUARDS[value.type](value)
  );
}

// src/limits.ts, src/end-state.ts (v2: endState and suggestions, spec 13.15; no chips), src/run-error.ts (v2: reason)
const isLimitPayload = objectOf({ reason: oneOf(LIMIT_REASONS), locale: oneOf(LOCALES) }, STRICT);
const isSuggestion = objectOf({ intent: oneOf(INTENT_IDS), label: str(1, SUGGESTION_LABEL_MAX), send: str(1, SUGGESTION_SEND_MAX) }, STRICT);
const isEndPayload = objectOf({ endState: oneOf(END_STATES), suggestions: arrayOf(isSuggestion, 0, SUGGESTIONS_MAX) }, STRICT);
const isRunErrorBodyShape = objectOf(
  { code: str(), message: str(0, 300), retryAfterSec: optional(intIn()), reason: optional(oneOf(GATE_REASONS)) },
  STRICT,
);

/** Same verdict as RunErrorBodySchema.safeParse(value).success; `code` stays an open string, `reason` is one of GATE_REASONS. */
export function isRunErrorBody(value) {
  return isRunErrorBodyShape(value);
}

// src/events.ts
const eventOf = (type, shape) => objectOf({ type: literal(type), seq: intIn(0), ...shape });
const CUSTOM_GUARDS = {
  'olivia.card': eventOf('CUSTOM', { name: literal('olivia.card'), value: isCard }),
  'olivia.limit': eventOf('CUSTOM', { name: literal('olivia.limit'), value: isLimitPayload }),
  'olivia.end': eventOf('CUSTOM', { name: literal('olivia.end'), value: isEndPayload }),
  // D18: the server takes back a streamed message; reduceTurn drops its text
  'olivia.text.retract': eventOf('CUSTOM', { name: literal('olivia.text.retract'), value: objectOf({ messageId: str(1) }, STRICT) }),
};
const EVENT_GUARDS = {
  RUN_STARTED: eventOf('RUN_STARTED', {
    threadId: str(),
    runId: str(),
    protocolVersion: literal(OLIVIA_PROTOCOL_VERSION),
  }),
  TEXT_MESSAGE_START: eventOf('TEXT_MESSAGE_START', { messageId: str(), role: literal('assistant') }),
  TEXT_MESSAGE_CONTENT: eventOf('TEXT_MESSAGE_CONTENT', { messageId: str(), delta: str(1, 2000) }),
  TEXT_MESSAGE_END: eventOf('TEXT_MESSAGE_END', { messageId: str() }),
  TOOL_CALL_START: eventOf('TOOL_CALL_START', { toolCallId: str(), toolCallName: oneOf(TOOL_NAMES) }),
  TOOL_CALL_END: eventOf('TOOL_CALL_END', { toolCallId: str() }),
  CUSTOM: (v) => typeof v.name === 'string' && Object.hasOwn(CUSTOM_GUARDS, v.name) && CUSTOM_GUARDS[v.name](v),
  RUN_FINISHED: eventOf('RUN_FINISHED', { threadId: str(), runId: str() }),
  RUN_ERROR: eventOf('RUN_ERROR', { message: str(0, 300), code: str() }),
};

/** Same verdict as OliviaEventSchema.safeParse(value).success. */
export function isOliviaEvent(value) {
  return (
    isRecord(value) &&
    typeof value.type === 'string' &&
    Object.hasOwn(EVENT_GUARDS, value.type) &&
    EVENT_GUARDS[value.type](value)
  );
}

// src/run-request.ts
const isRunRequestShape = objectOf(
  {
    protocolVersion: literal(OLIVIA_PROTOCOL_VERSION),
    threadId: matches(UUID),
    clientTurnId: matches(UUID),
    locale: oneOf(LOCALES),
    country: isCountryCode,
    currency: isCurrencyCode,
    page: objectOf({ template: str(0, 40), handle: optional(str(0, 120)) }, STRICT),
    message: str(1, MESSAGE_MAX),
    intent: optional(oneOf(INTENT_IDS)),
    testSecret: optional(str()),
  },
  STRICT,
);

/** Same verdict as RunRequestSchema.safeParse(value).success. */
export function isRunRequest(value) {
  return isRunRequestShape(value);
}

// src/thread.ts: the answer of GET /apps/olivia/thread (spec 13.4). The query side is
// ThreadQuerySchema, which buildThreadUrl() writes and wire.test.mjs holds to its fixture.
const isThreadTurn = objectOf(
  {
    runId: str(),
    at: isIsoDatetime,
    you: str(0, MESSAGE_MAX),
    answer: str(),
    cards: arrayOf(isCard, 0, CARDS_PER_RUN_MAX),
    endState: nullable(oneOf(END_STATES)),
    limitReason: nullable(oneOf(LIMIT_REASONS)),
  },
  STRICT,
);
const isThreadResponseShape = objectOf({ threadId: matches(UUID), turns: arrayOf(isThreadTurn, 0, THREAD_TURNS_MAX) }, STRICT);

/** Same verdict as ThreadResponseSchema.safeParse(value).success. */
export function isThreadResponse(value) {
  return isThreadResponseShape(value);
}

// src/signal.ts: the body of POST /apps/olivia/signal (contract C7).
const isSignalRequestShape = objectOf(
  { protocolVersion: literal(OLIVIA_PROTOCOL_VERSION), threadId: matches(UUID), runId: str(1, 64), kind: oneOf(SIGNAL_KINDS) },
  STRICT,
);

/** Same verdict as SignalRequestSchema.safeParse(value).success. */
export function isSignalRequest(value) {
  return isSignalRequestShape(value);
}

/** GET /apps/olivia/thread for one thread (contract C2); ThreadQuerySchema coerces `v` to the protocol version. */
export function buildThreadUrl(threadId) {
  const query = new URLSearchParams({ threadId, v: String(OLIVIA_PROTOCOL_VERSION) });
  return `${ENDPOINTS.thread}?${query}`;
}

/** The POST /apps/olivia/signal body, keys in SignalRequestSchema order. No goal: the server attributes the signal (spec 13.4). */
export function buildSignalRequest({ threadId, runId, kind }) {
  return { protocolVersion: OLIVIA_PROTOCOL_VERSION, threadId, runId, kind };
}

// The thread memory of the browser (contract C6): localStorage[THREAD_KEY] holds
// {"v":1,"id":"<uuid>","expiresAt":"<iso>"}. It is read at load and nothing more, written only by a
// voluntary send (expiry renewed to THREAD_TTL_DAYS each time) and removed by "Nuova conversazione".
// A malformed or expired record is ignored here and replaced or removed at the next voluntary action.
// The storage is passed in, so this section still touches no global and Node tests use a stand-in;
// a storage that throws (blocked site storage, a full quota) is one console.warn and reads as no thread.
const THREAD_RECORD_VERSION = 1;
const DAY_MS = 86_400_000;
const isThreadRecord = objectOf({ v: literal(THREAD_RECORD_VERSION), id: matches(UUID), expiresAt: isIsoDatetime, token: optional(matches(/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/, 800)) }, STRICT);

// `now` is Date.now(): a Date would turn `now + ms` into a string.
function assertTimestamp(now) {
  if (typeof now !== 'number' || !Number.isFinite(now)) throw new RangeError('olivia: now must be Date.now() milliseconds');
}

/** { id } for a valid record, { expired: true } for a valid record past its expiry, null for none or a malformed one. Never writes. */
export function readStoredThread(storage, now) {
  assertTimestamp(now);
  let raw;
  try {
    raw = storage.getItem(THREAD_KEY);
  } catch (error) {
    console.warn('olivia: thread storage is not readable', error);
    return null;
  }
  if (raw === null) return null;
  let record;
  try {
    record = JSON.parse(raw);
  } catch (error) {
    if (!(error instanceof SyntaxError)) throw error;
    console.warn('olivia: the stored thread is not JSON; ignored');
    return null;
  }
  if (!isThreadRecord(record)) {
    console.warn('olivia: the stored thread is not a v1 record; ignored');
    return null;
  }
  return Date.parse(record.expiresAt) <= now ? { expired: true } : { id: record.id, ...(record.token ? { token: record.token } : {}) };
}

/** Writes the record of `id`, expiring THREAD_TTL_DAYS after `now`; true when written. A non-UUID id is a bug: RangeError. */
export function storeThread(storage, id, now, capability) {
  assertTimestamp(now);
  if (typeof id !== 'string' || !UUID.test(id)) throw new RangeError('olivia: the thread id is not a UUID');
  const record = { v: THREAD_RECORD_VERSION, id, expiresAt: capability?.expiresAt ?? new Date(now + THREAD_TTL_DAYS * DAY_MS).toISOString(), ...(capability?.token ? { token: capability.token } : {}) };
  if (!isThreadRecord(record)) throw new RangeError('olivia: invalid session capability');
  try {
    storage.setItem(THREAD_KEY, JSON.stringify(record));
    return true;
  } catch (error) {
    console.warn('olivia: thread storage is not writable', error);
    return false;
  }
}

/** Removes the record ("Nuova conversazione"); true when removed. */
export function clearStoredThread(storage) {
  try {
    storage.removeItem(THREAD_KEY);
    return true;
  } catch (error) {
    console.warn('olivia: thread storage is not writable', error);
    return false;
  }
}

/**
 * One SSE frame ({ id?, event?, data }) to a typed event, or undefined with a console.warn.
 * The server writes `id: <seq>` and `event: <type>` (Plan A toSSEFrame), so a frame whose
 * id or event disagrees with its own payload is refused like a malformed one.
 */
export function parseEvent(frame) {
  let value;
  try {
    value = JSON.parse(frame.data);
  } catch (error) {
    console.warn('olivia: SSE data is not JSON', frame.event, error);
    return undefined;
  }
  if (!isOliviaEvent(value)) {
    console.warn('olivia: unknown or malformed event', frame.event);
    return undefined;
  }
  if (frame.event !== undefined && frame.event !== value.type) {
    console.warn('olivia: SSE event name does not match the payload type', frame.event, value.type);
    return undefined;
  }
  if (frame.id !== undefined && frame.id !== String(value.seq)) {
    console.warn('olivia: SSE id does not match the payload seq', frame.id, value.seq);
    return undefined;
  }
  return value;
}

/** The locale OlivIA answers in: it, en, fr, de as they are, anything else en (spec 4.4). */
export function mapLocale(isoCode) {
  return LOCALES.includes(isoCode) ? isoCode : 'en';
}

/**
 * The POST /apps/olivia/run body, keys in RunRequestSchema order. `page.handle` is a hint: it
 * is left out when absent or longer than the wire bound, so a long handle never fails the turn.
 * `testSecret` travels only when the theme setting holds one.
 */
export function buildRunRequest({ threadId, clientTurnId, locale, country, currency, template, handle, message, intent, testSecret }) {
  const page = handle && handle.length <= 120 ? { template, handle } : { template };
  return {
    protocolVersion: OLIVIA_PROTOCOL_VERSION,
    threadId,
    clientTurnId,
    locale: mapLocale(locale),
    country,
    currency,
    page,
    message,
    // spec 13.15: only a tapped suggestion names its intent; a typed question names none
    ...(INTENT_IDS.includes(intent) ? { intent } : {}),
    ...(testSecret ? { testSecret } : {}),
  };
}

/**
 * Integer cents to text with shop.money_format: the logic of money() in
 * assets/lab-shipping-quote.js without its multi-currency branch, since cards carry EUR only.
 */
export function formatMoney(cents, moneyFormat) {
  const amount = cents / 100;
  // Thousands grouping as fixed() in assets/lab-bottom-strip.js, so 123450 reads 1.234,50
  const fixed = (decimals, thousands, decimal) => {
    const [whole, fraction] = amount.toFixed(decimals).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? `${grouped}${decimal}${fraction}` : grouped;
  };
  return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
    if (key === 'amount_with_comma_separator') return fixed(2, '.', ',');
    if (key === 'amount_no_decimals') return fixed(0, ',', '.');
    if (key === 'amount_no_decimals_with_comma_separator') return fixed(0, '.', ',');
    return fixed(2, ',', '.');
  });
}

/** Cents per litre, rounded to the cent (spec 4.3: the theme computes the price per litre). */
export function perLitre(cents, litres) {
  return Math.round(cents / litres);
}

/**
 * A root-less path (card href, '/checkout') under routes.root_url. Not for URLs Liquid already
 * localised, such as pages['contact'].url. Throws RangeError for anything the URL parser would
 * send off the shop's origin: '//host', 'https://host', and the '/\host' and '/<tab>/host'
 * forms that HrefSchema still lets through.
 */
export function withRoot(root, href) {
  const base = 'https://shop.invalid';
  const joined = typeof href === 'string' && HREF.test(href) ? `${root.replace(/\/+$/, '')}${href}` : null;
  if (joined === null || new URL(joined, base).origin !== base) {
    throw new RangeError(`olivia: not a same-origin path: ${JSON.stringify(href)}`);
  }
  return joined;
}

/* ── wire: transport (Plan B Task 4, Plan C Task 9; spec 4.5, 4.3, 7.3, 13.4, 13.11) ──────────────
   openSSE knows endpoint, headers, body and SSE framing; parseEvent (above) knows the event types.
   fetchThread knows GET /apps/olivia/thread, sendSignal POST /apps/olivia/signal, addToCart the Ajax
   cart. None touches the DOM. Every failure says whether its body was JSON at all: the Shopify app
   proxy answers any 5xx of the app with the store's HTML 500 page (spec 13.11), and a body that is
   not JSON is what tells "something between the page and OlivIA failed" from "OlivIA said no". */

// A blank line ends an SSE frame. The server writes LF (toSSEFrame); CRLF is accepted too.
const SSE_FRAME_END = /\r?\n\r?\n/;

// Deadline of one /cart/add.js call; the Ajax cart answers in well under a second.
const CART_TIMEOUT_MS = 15_000;
// Deadline of one GET /apps/olivia/thread: a database read behind the proxy, no inference.
const THREAD_TIMEOUT_MS = 15_000;
// Deadline of one POST /apps/olivia/signal; keepalive lets it finish after the page navigates.
const SIGNAL_TIMEOUT_MS = 10_000;

// Media types read as a JSON body. The app routes answer application/json; the Ajax cart answers
// application/json on a 422 and text/javascript on GET /cart.js (live store, 2026-10-07): both are JSON.
const JSON_MEDIA_TYPES = ['application/json'];
const CART_MEDIA_TYPES = ['application/json', 'text/javascript'];

/**
 * Thrown by openSSE and fetchThread before they yield or return anything: 'bad status' for a non-2xx,
 * 'bad response' for a 2xx whose body is not what the route promises. `json` is true only when the
 * body was JSON; code, reason and retryAfterSec come from a RunErrorBody (retryAfterSec also from
 * Retry-After). toHttpInput turns it into the turn machine's `http` input (contract C4).
 */
export class OliviaTransportError extends HTTPError {
  constructor(message, status, { json = false, code, reason, retryAfterSec } = {}) {
    super(message, status);
    this.name = 'OliviaTransportError';
    this.json = json === true;
    this.code = code;
    this.reason = reason;
    this.retryAfterSec = retryAfterSec;
  }
}

/** Thrown by addToCart for any answer that is not a 2xx cart JSON; `description` is Shopify's text or ''. */
export class OliviaCartError extends Error {
  constructor(status, description) {
    super(`cart add failed (${status})`);
    this.name = 'OliviaCartError';
    this.status = status;
    this.description = description;
  }
}

// 'text/event-stream; charset=utf-8' -> 'text/event-stream'
function contentTypeOf(response) {
  return (response.headers.get('content-type') ?? '').split(';')[0].trim().toLowerCase();
}

// Retry-After in delta-seconds; an HTTP-date reads as absent and the band waits DEFAULT_COOLDOWN_SEC.
function retryAfterSeconds(response) {
  const raw = (response.headers.get('retry-after') ?? '').trim();
  return /^\d+$/.test(raw) ? Number(raw) : undefined;
}

// { json: true, value } when the content-type is one of `mediaTypes` and the body parses; otherwise
// { json: false }, with the body cancelled unread (another media type) or reported (broken JSON).
// A network or abort failure while reading propagates.
async function readJson(response, mediaTypes) {
  if (!mediaTypes.includes(contentTypeOf(response))) {
    await response.body?.cancel();
    return { json: false };
  }
  try {
    return { json: true, value: await response.json() };
  } catch (error) {
    if (!(error instanceof SyntaxError)) throw error;
    console.warn('olivia: response body is not JSON', response.status);
    return { json: false };
  }
}

// The OliviaTransportError of a non-2xx answer of an app route.
async function statusError(response) {
  const read = await readJson(response, JSON_MEDIA_TYPES);
  const body = read.json && isRunErrorBody(read.value) ? read.value : undefined;
  if (read.json && body === undefined) console.warn('olivia: error body outside RunErrorBodySchema', response.status);
  return new OliviaTransportError('bad status', response.status, {
    json: read.json,
    code: body?.code,
    reason: body?.reason,
    retryAfterSec: body?.retryAfterSec ?? retryAfterSeconds(response),
  });
}

// The caller's signal (Escape, close, a new question) joined with the client deadline. Hand-rolled
// instead of AbortSignal.any (Safari 17.4+) so iOS 16 keeps working; clear() drops the timer.
function withClientDeadline(signal, timeoutMs) {
  const controller = new AbortController();
  const onAbort = () => controller.abort(signal.reason);
  const timer = setTimeout(() => controller.abort(new DOMException('OlivIA client deadline', 'TimeoutError')), timeoutMs);
  if (signal.aborted) onAbort();
  else signal.addEventListener('abort', onAbort, { once: true });
  return {
    signal: controller.signal,
    clear() {
      clearTimeout(timer);
      signal.removeEventListener('abort', onAbort);
    },
  };
}

// One frame, or undefined for a comment (": ping") or a frame parseSSEFrame rejects (reported, dropped).
function frameOrSkip(raw) {
  try {
    return parseSSEFrame(raw);
  } catch (error) {
    if (!(error instanceof ProtocolParseError)) throw error;
    console.warn('olivia: SSE frame dropped', error.message);
    return undefined;
  }
}

// Bytes -> frames. Text decoding is streaming (a UTF-8 character may straddle two chunks); the tail after
// the last blank line waits for the next chunk. A reader that has not reported done or an error when the
// generator exits (the consumer stopped early, or a frame threw) is cancelled, which closes the request.
async function* readSSEFrames(reader) {
  const decoder = new TextDecoder();
  let buffer = '';
  let settled = false;
  try {
    for (;;) {
      const chunk = await reader.read().catch((error) => {
        settled = true;
        throw error;
      });
      if (chunk.done) {
        settled = true;
        break;
      }
      buffer += decoder.decode(chunk.value, { stream: true });
      const parts = buffer.split(SSE_FRAME_END);
      buffer = parts.pop();
      for (const raw of parts) {
        const frame = frameOrSkip(raw);
        if (frame !== undefined) yield frame;
      }
    }
    buffer += decoder.decode();
    if (buffer.trim() !== '') console.warn('olivia: stream ended inside a frame; frame dropped');
  } finally {
    if (!settled) await reader.cancel();
  }
}

/**
 * POST a RunRequest body to the app proxy and yield its SSE frames ({ id?, event?, data }).
 * Nothing is sent before the first next(). Before the first frame it throws OliviaTransportError:
 * 'bad status' for a non-2xx (code and retryAfterSec from the RunErrorBody when the body is JSON,
 * retryAfterSec from Retry-After otherwise), 'bad response' for a 2xx without an event-stream body.
 * Aborting `signal` (abort() without a reason) rejects with an AbortError, `timeoutMs` (default
 * CLIENT_TIMEOUT_MS) with a TimeoutError, a network failure with a TypeError; toHttpInput maps them all.
 */
/** Obtain or renew a server-issued capability only after a voluntary send; no model is called. */
export async function obtainSession(token, signal, fetchImpl = globalThis.fetch) {
  const deadline = withClientDeadline(signal, THREAD_TIMEOUT_MS);
  try {
    const response = await fetchImpl(SESSION_ENDPOINT, {
      method: 'POST', headers: new Headers({ 'content-type': 'application/json' }),
      body: JSON.stringify({ protocolVersion: OLIVIA_PROTOCOL_VERSION, ...(token ? { token } : {}) }),
      signal: deadline.signal,
    });
    if (!response.ok) throw await statusError(response);
    const read = await readJson(response, JSON_MEDIA_TYPES);
    const value = read.value;
    if (!read.json || !isRecord(value) || !UUID.test(value.threadId ?? '') ||
        !isIsoDatetime(value.expiresAt) || Date.parse(value.expiresAt) <= Date.now() ||
        !matches(/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/, 800)(value.token)) {
      throw new OliviaTransportError('bad response', response.status, { json: read.json });
    }
    return value;
  } catch (error) { throw deadline.signal.aborted ? deadline.signal.reason : error; }
  finally { deadline.clear(); }
}

export const ANALYTICS_HEADER = 'x-olivia-analytics';
export const ANALYTICS_ENDPOINT = '/apps/olivia/analytics';
export const ATTRIBUTION_ENDPOINT = '/apps/olivia/attribution';
export const ATTRIBUTION_ATTRIBUTE = '__olivia_receipt';
const analyticsAllowed = () => globalThis.OlioConsentStore?.readValid?.()?.analytics === true;
export function validAnalyticsContext(value) {
  return isRecord(value) && value.consent === true && /^\d{1,20}\.\d{1,20}$/.test(value.clientId ?? '') && /^\d{8,16}$/.test(value.sessionId ?? '') && Object.keys(value).length === 3;
}
/** Recognized Google cookie versions only; unknown formats fail closed rather than inventing a user/session. */
export function analyticsFromCookies(cookie, allowed) {
  if (allowed !== true) return null;
  let cookies;
  try { cookies = Object.fromEntries(cookie.split(';').map(part => { const at = part.indexOf('='); return [part.slice(0, at).trim(), decodeURIComponent(part.slice(at + 1))]; })); }
  catch { return null; }
  const clientId = cookies._ga?.match(/^GA\d+\.\d+\.(\d{1,20}\.\d{1,20})$/)?.[1];
  const raw = cookies._ga_L9FFD504B5 ?? '';
  const sessionId = raw.match(/^GS2\.\d+\.(?:[^$]*\$)*s(\d{8,16})(?:\$|$)/)?.[1] ?? raw.match(/^GS1\.\d+\.(\d{8,16})\./)?.[1];
  const value = { consent: true, clientId, sessionId };
  return validAnalyticsContext(value) ? value : null;
}
export async function captureAnalyticsContext(allowed = analyticsAllowed, get = globalThis.gtag, cookie = () => globalThis.document?.cookie ?? '') {
  if (!allowed()) return null;
  // Prefer the supported gtag get interface. The fallback recognizes existing cookies only.
  const read = (field) => new Promise(resolve => {
    if (typeof get !== 'function') { resolve(undefined); return; }
    const timer = setTimeout(() => resolve(undefined), 150);
    try { get('get', 'G-L9FFD504B5', field, value => { clearTimeout(timer); resolve(value); }); }
    catch { clearTimeout(timer); resolve(undefined); }
  });
  const [clientId, sessionId] = await Promise.all([read('client_id'), read('session_id')]);
  if (!allowed()) return null;
  const value = { consent: true, clientId: String(clientId ?? ''), sessionId: String(sessionId ?? '') };
  return validAnalyticsContext(value) ? value : analyticsFromCookies(cookie(), true);
}
export async function sendAnalyticsResult({ threadId, runId, token, context }, fetchImpl = globalThis.fetch) {
  if (!validAnalyticsContext(context)) return false;
  try {
    const response = await fetchImpl(ANALYTICS_ENDPOINT, { method: 'POST', keepalive: true, headers: sessionHeaders({ 'content-type': 'application/json' }, token, context), body: JSON.stringify({ protocolVersion: OLIVIA_PROTOCOL_VERSION, threadId, runId, event: 'result' }), signal: AbortSignal.timeout(SIGNAL_TIMEOUT_MS) });
    await response.body?.cancel(); return response.ok;
  } catch { return false; }
}
export async function clearCartAttribution(root, fetchImpl = globalThis.fetch) {
  try {
    const response = await fetchImpl(withRoot(root || '/', '/cart/update.js'), { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ attributes: { [ATTRIBUTION_ATTRIBUTE]: '' } }), signal: AbortSignal.timeout(1200) });
    await response.body?.cancel(); return response.ok;
  } catch { return false; }
}
/** Best effort after a successful cart add. Only analytics consent permits linking to a conversation. */
export async function attributeCart({ threadId, runId, token, root, variants }, allowed = analyticsAllowed, fetchImpl = globalThis.fetch) {
  if (!allowed()) return false;
  const signal = AbortSignal.timeout(1200); // one shared deadline bounds the entire extra checkout path
  try {
    const response = await fetchImpl(ATTRIBUTION_ENDPOINT, { method: 'POST', headers: sessionHeaders({ 'content-type': 'application/json' }, token), body: JSON.stringify({ protocolVersion: OLIVIA_PROTOCOL_VERSION, threadId, runId, variants }), signal });
    const read = await readJson(response, JSON_MEDIA_TYPES);
    if (!response.ok || !read.json || !matches(/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{43}$/, 1600)(read.value?.receipt) || !allowed()) return false;
    const update = await fetchImpl(withRoot(root || '/', '/cart/update.js'), { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ attributes: { [ATTRIBUTION_ATTRIBUTE]: read.value.receipt } }), signal });
    await update.body?.cancel();
    if (!allowed()) { await clearCartAttribution(root, fetchImpl); return false; }
    return update.ok;
  } catch { return false; }
}

function sessionHeaders(values, token, analytics) {
  const headers = new Headers(values);
  if (validAnalyticsContext(analytics)) headers.set(ANALYTICS_HEADER, JSON.stringify(analytics));
  if (token) headers.set(SESSION_HEADER, token);
  return headers;
}

export async function* openSSE(endpoint, body, signal, fetchImpl = globalThis.fetch, timeoutMs = CLIENT_TIMEOUT_MS, token, analytics) {
  const deadline = withClientDeadline(signal, timeoutMs);
  try {
    const response = await fetchImpl(endpoint, {
      method: 'POST',
      headers: sessionHeaders({ 'content-type': 'application/json', accept: 'text/event-stream' }, token, analytics),
      body,
      signal: deadline.signal,
    });
    if (!response.ok) throw await statusError(response);
    if (response.body === null || contentTypeOf(response) !== 'text/event-stream') {
      await response.body?.cancel();
      throw new OliviaTransportError('bad response', response.status);
    }
    yield* readSSEFrames(response.body.getReader());
  } catch (error) {
    // WebKit rejects an aborted fetch or read with a generic AbortError, not the signal's reason; the
    // reason (AbortError from the visitor, TimeoutError from the deadline) is the one that counts.
    throw deadline.signal.aborted ? deadline.signal.reason : error;
  } finally {
    deadline.clear();
  }
}

/**
 * GET one thread (contract C2) and resolve with its ThreadResponse; only on "Riprendi la conversazione",
 * never at load. Rejects like openSSE: OliviaTransportError 'bad status' for a non-2xx, 'bad response'
 * for a 2xx that is not JSON (json false: the store's page) or not a ThreadResponse of this thread
 * (json true, one console.warn); TimeoutError after `timeoutMs`, AbortError when `signal` aborts,
 * TypeError on a network failure. toHttpInput maps every one of them for fromHttp.
 */
export async function fetchThread(threadId, signal, fetchImpl = globalThis.fetch, timeoutMs = THREAD_TIMEOUT_MS, token) {
  const deadline = withClientDeadline(signal, timeoutMs);
  try {
    const response = await fetchImpl(buildThreadUrl(threadId), {
      method: 'GET',
      headers: sessionHeaders({ accept: 'application/json' }, token),
      signal: deadline.signal,
    });
    if (!response.ok) throw await statusError(response);
    const read = await readJson(response, JSON_MEDIA_TYPES);
    if (!read.json) throw new OliviaTransportError('bad response', response.status);
    if (!isThreadResponse(read.value) || read.value.threadId !== threadId) {
      console.warn('olivia: thread body outside ThreadResponseSchema', response.status);
      throw new OliviaTransportError('bad response', response.status, { json: true });
    }
    return read.value;
  } catch (error) {
    throw deadline.signal.aborted ? deadline.signal.reason : error;
  } finally {
    deadline.clear();
  }
}

/**
 * POST /apps/olivia/signal after a visible action of the visitor (contract C7), with keepalive, so a
 * signal sent right before location.assign still leaves. Resolves true on a 2xx (the route answers
 * 204). Never throws and never changes the UI: a refused or failed signal is one console.warn with the
 * kind and the status only (no id reaches a log). An input outside SignalRequestSchema is not sent.
 */
export async function sendSignal({ threadId, runId, kind, token, analytics }, fetchImpl = globalThis.fetch) {
  const request = buildSignalRequest({ threadId, runId, kind });
  if (!isSignalRequest(request)) {
    console.warn('olivia: signal outside SignalRequestSchema; not sent', kind);
    return false;
  }
  try {
    const response = await fetchImpl(ENDPOINTS.signal, {
      method: 'POST',
      keepalive: true,
      headers: sessionHeaders({ 'content-type': 'application/json' }, token, analytics),
      body: JSON.stringify(request),
      signal: AbortSignal.timeout(SIGNAL_TIMEOUT_MS),
    });
    await response.body?.cancel();
    if (response.ok) return true;
    console.warn('olivia: signal refused', kind, response.status);
    return false;
  } catch (error) {
    console.warn('olivia: signal not delivered', kind, error?.name);
    return false;
  }
}

/**
 * The turn machine's `http` input (contract C4, D8) for a failure of openSSE before RUN_STARTED or of
 * fetchThread. null = the visitor aborted on purpose (Escape, Chiudi, a new question): nothing to show.
 * Any other error is a bug in this file: it is rethrown, never shown as a generic error.
 */
export function toHttpInput(error) {
  if (error instanceof OliviaTransportError) {
    return {
      kind: 'http',
      status: error.status,
      json: error.json,
      ...(error.code === undefined ? {} : { code: error.code }),
      ...(error.reason === undefined ? {} : { reason: error.reason }),
      ...(error.retryAfterSec === undefined ? {} : { retryAfterSec: error.retryAfterSec }),
    };
  }
  if (error instanceof DOMException && error.name === 'TimeoutError') return { kind: 'http', status: 0, json: false, code: 'TIMEOUT' };
  if (error instanceof DOMException && error.name === 'AbortError') return null;
  if (error instanceof TypeError) {
    console.error('olivia: request failed', error);
    return { kind: 'http', status: 0, json: false, code: 'ABORTED' };
  }
  throw error;
}

// CartLine (olivia-protocol cards.ts) -> Ajax cart item. Variant ids travel as digit strings; the
// number must be exact, or the cart would get a neighbouring variant.
function toCartItem(line) {
  const id = Number(line.variantId);
  if (!Number.isSafeInteger(id)) throw new RangeError(`variant id out of range: ${line.variantId}`);
  return line.properties === undefined ? { id, quantity: line.qty } : { id, quantity: line.qty, properties: line.properties };
}

/**
 * Add card lines to the cart (spec 4.3, 7.3): POST `${cartAddUrl}.js` with {items:[{id, quantity, properties}]}.
 * Resolves with the /cart/add.js JSON ({ items: [...] }, the added lines: subscribers of
 * PUB_SUB_EVENTS.cartUpdate fetch the totals themselves, as after a PDP add). A non-2xx, or a 2xx that
 * is not that JSON, rejects with OliviaCartError; a network failure with the fetch TypeError.
 */
export async function addToCart(cartAddUrl, lines, fetchImpl = globalThis.fetch) {
  const items = lines.map(toCartItem);
  const response = await fetchImpl(`${cartAddUrl}.js`, {
    method: 'POST',
    headers: new Headers({ 'content-type': 'application/json', accept: 'application/json' }),
    body: JSON.stringify({ items }),
    signal: AbortSignal.timeout(CART_TIMEOUT_MS),
  });
  const { value } = await readJson(response, CART_MEDIA_TYPES);
  if (!response.ok) {
    throw new OliviaCartError(response.status, typeof value?.description === 'string' ? value.description : '');
  }
  if (!Array.isArray(value?.items)) throw new OliviaCartError(response.status, '');
  return value;
}

/* ── wire: panel (Plan C Task 8; spec 13.1, 13.2, contract C5) ────────────────────────────────
   Where the conversation sits on screen, as a pure machine: the header bar with a fresh field
   (bar_new) or with "Riprendi la conversazione" (bar_resume), the transcript being fetched
   (resuming), the panel (open), the composer alone at the bottom (docked). UI only: sending,
   streaming and errors belong to the turn machine of the protocol region. The DOM maps Escape
   to `close`, and sends `abort` to the turn machine before `close` and `new` (Riduci does not).
   hasThread is the read-only verdict on the stored thread: nothing here touches storage, and
   nothing runs at load. tools/olivia/panel.test.mjs holds all 5 × 8 pairs. */
export const PANEL_STATES = ['bar_new', 'bar_resume', 'resuming', 'open', 'docked'];
export const PANEL_INPUT_KEYS = ['send', 'resume', 'loaded', 'load_failed', 'reduce', 'expand', 'new', 'close'];

// The bar a closed conversation leaves behind: "Riprendi" only while a thread is still stored.
const barFor = (hasThread) => (hasThread === true ? 'bar_resume' : 'bar_new');

/** The surface at load, from the stored-thread verdict alone (true = a valid thread is stored). */
export function initialPanel(hasThread) {
  return barFor(hasThread);
}

/**
 * One step of the panel machine. `input` is { kind } with kind in PANEL_INPUT_KEYS; `close`
 * carries hasThread too. The pairs the contract does not name leave the state as it is; a state
 * or a kind outside the two lists throws UnreachableError.
 */
export function reducePanel(state, input) {
  switch (state) {
    case 'bar_new':
      switch (input.kind) {
        case 'send':
          return 'open';
        case 'resume': case 'loaded': case 'load_failed': case 'reduce': case 'expand': case 'new': case 'close':
          return state;
        default:
          return assertNever(input);
      }
    case 'bar_resume':
      switch (input.kind) {
        case 'resume':
          return 'resuming';
        case 'send': case 'loaded': case 'load_failed': case 'reduce': case 'expand': case 'new': case 'close':
          return state;
        default:
          return assertNever(input);
      }
    case 'resuming':
      switch (input.kind) {
        case 'loaded': case 'load_failed':
          return 'open';
        case 'close':
          return barFor(input.hasThread);
        case 'send': case 'resume': case 'reduce': case 'expand': case 'new':
          return state;
        default:
          return assertNever(input);
      }
    case 'open':
      switch (input.kind) {
        case 'reduce':
          return 'docked';
        case 'new':
          return 'open';
        case 'close':
          return barFor(input.hasThread);
        case 'send': case 'resume': case 'loaded': case 'load_failed': case 'expand':
          return state;
        default:
          return assertNever(input);
      }
    case 'docked':
      switch (input.kind) {
        case 'expand':
          return 'open';
        case 'close':
          return barFor(input.hasThread);
        case 'send': case 'resume': case 'loaded': case 'load_failed': case 'reduce': case 'new':
          return state;
        default:
          return assertNever(input);
      }
    default:
      return assertNever(state);
  }
}

/* ── layout (owner correction 2026-10-08): band by default, the panel as the alternative ───────────────
   settings.olivia_layout (config/settings_schema.json) decides which snippet layout/lab.liquid renders
   beside the bar, and reaches the script as data-layout on <lab-olivia-bar>, read once at upgrade. The
   runtime (ShopClaude) never sees it. */
export const LAYOUTS = ['band', 'panel'];
export const DEFAULT_LAYOUT = 'band';

/** The layout of a data-layout value: anything but a known layout is the default. */
export function readLayout(value) {
  return LAYOUTS.includes(value) ? value : DEFAULT_LAYOUT;
}

/* ── reversible reading surface ─────────────────────────────────────────────────────────────
   The dock always keeps the writing field. A saved capability offers explicit restoration;
   an in-memory docked conversation reopens without a request. Reducing keeps the stream,
   history and draft. Only End conversation/new clears the active thread. */
export const BAND_STATES = ['bar_new', 'bar_resume', 'resuming', 'open', 'docked'];
export const BAND_INPUT_KEYS = ['send', 'resume', 'loaded', 'load_failed', 'new', 'close', 'reduce', 'expand'];

/** The surface at load, from the stored-thread verdict alone. */
export function initialBand(hasThread) {
  return barFor(hasThread);
}

/**
 * One step of the band machine. `input` is { kind } with kind in BAND_INPUT_KEYS; `close` carries
 * hasThread too. The pairs the contract does not name leave the state as it is; a state or a kind
 * outside the two lists throws UnreachableError.
 */
export function reduceBand(state, input) {
  switch (state) {
    case 'bar_new':
      switch (input.kind) {
        case 'send':
          return 'open';
        case 'resume': case 'loaded': case 'load_failed': case 'new': case 'close': case 'reduce': case 'expand':
          return state;
        default:
          return assertNever(input);
      }
    case 'bar_resume':
      switch (input.kind) {
        case 'send':
          return 'open';
        case 'resume':
          return 'resuming';
        case 'loaded': case 'load_failed': case 'new': case 'close': case 'reduce': case 'expand':
          return state;
        default:
          return assertNever(input);
      }
    case 'resuming':
      switch (input.kind) {
        case 'loaded': case 'load_failed':
          return 'open';
        case 'close':
          return barFor(input.hasThread);
        case 'reduce':
          return 'bar_resume';
        case 'new':
          return 'bar_new';
        case 'send': case 'resume': case 'expand':
          return state;
        default:
          return assertNever(input);
      }
    case 'open':
      switch (input.kind) {
        case 'send':
          return 'open';
        case 'new':
          return 'bar_new';
        case 'close':
          return barFor(input.hasThread);
        case 'reduce':
          return 'docked';
        case 'resume': case 'loaded': case 'load_failed': case 'expand':
          return state;
        default:
          return assertNever(input);
      }
    case 'docked':
      switch (input.kind) {
        case 'send': case 'resume': case 'expand': return 'open';
        case 'new': return 'bar_new';
        case 'close': return barFor(input.hasThread);
        case 'loaded': case 'load_failed': case 'reduce': return state;
        default: return assertNever(input);
      }
    default:
      return assertNever(state);
  }
}

/** The reading surface, the persistent field's optional return action, and transcript loading. */
export function bandTraits(state) {
  switch (state) {
    case 'bar_new':
      return { band: false, bar: 'new', busy: false };
    case 'bar_resume':
      return { band: false, bar: 'resume', busy: false };
    case 'resuming':
      return { band: true, bar: 'resume', busy: true };
    case 'open':
      return { band: true, bar: 'new', busy: false };
    case 'docked':
      return { band: false, bar: 'resume', busy: false };
    default:
      return assertNever(state);
  }
}

/* ── wire: signals after a visible action (Task 13; spec 13.6, C7) ───────────────────────────────
   Which click becomes which POST /apps/olivia/signal. signalFor() decides from the clicked control
   and the card it sits in; signalScope() finds the answer it belongs to (the nearest data-run-id)
   and the stored thread (C6, the one source of the threadId); SignalBeacon lets each kind leave at
   most once per answer, through sendSignal (Task 9). The cart path signals itself: cart_added once
   /cart/add.js has answered 200, checkout_clicked right before location.assign(checkoutUrl).
   Nothing here runs at load, at render or when the band or panel opens: only the exchange's click
   listener and the cart button call in, so pointerdown and keydown are not listened to (a keyboard
   activation of a link is a click too; a middle click fires auxclick and sends nothing). These are
   not the analytics booleans of 7.5: olivia_cta stays as it is, behind the analytics consent; a
   signal goes to ShopClaude only and carries two ids and a kind, never text. */

// The path of a product page under any locale root: what withRoot() makes of '/products/<handle>'.
const PRODUCT_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/[a-z0-9-]+\/?$/i;

/** True for a same-origin href that opens a product page, with or without a query string. */
function isProductHref(href) {
  if (typeof href !== 'string' || !HREF.test(href)) return false;
  const base = 'https://shop.invalid';
  const url = new URL(href, base);
  return url.origin === base && PRODUCT_PATH.test(url.pathname);
}

/**
 * The signal a click inside an exchange sends, or null (spec 13.6, C7).
 * `target`: the clicked control, { tag: 'a', href, contact } for a link (contact: href is the
 * surface's data-contact-url) or { tag: 'button' } (a cart button signals from the cart path,
 * Riprova and Ricarica never); null when the click hit no control.
 * `card`: the Card the control sits in, or null for the exchange's actions row (the note and the
 * contact link of an error or a limit).
 * Product links count in product_plate, chip_row, cart_summary and avvisami_field; the links of
 * link_row never, not even one that opens a product page.
 */
/**
 * The path of a link's href as the click listener reads it: a relative href stays as it is; an
 * absolute href of `origin` becomes its pathname (query and hash dropped). The GA4 cross-domain
 * linker of the live site rewrites a card's href to an absolute URL with `?_gl=…` on the click
 * (found by Plan C Task 16 on www.oliottaviani.com), and the C7 rules read paths only.
 */
export function clickedPath(href, origin) {
  if (typeof href !== 'string') return '';
  if (typeof origin !== 'string' || origin === '' || !href.startsWith(`${origin}/`)) return href;
  try {
    return new URL(href).pathname;
  } catch {
    return href;
  }
}

export function signalFor(target, card) {
  if (target?.tag !== 'a') return null;
  if (card === null) return target.contact === true ? 'contact_clicked' : null;
  switch (card.type) {
    case 'contact_row':
      return 'contact_clicked';
    case 'product_plate':
    case 'chip_row':
    case 'cart_summary':
    case 'avvisami_field':
      return isProductHref(target.href) ? 'product_link_clicked' : null;
    case 'price_row':
    case 'band_row':
    case 'lot_instrument':
    case 'link_row':
      return null;
    default:
      return assertNever(card);
  }
}

/**
 * The ids of a signal for a control in an exchange (C7). runId: the data-run-id of the nearest
 * marked ancestor (the card slot, Task 10, or the exchange, Task 13). threadId: the stored thread,
 * through readThread() → { id } | { expired: true } | null (readStoredThread, C6), read only when
 * there is a run. { ok: false, reason: 'no_run' } for an exchange that failed before RUN_STARTED,
 * which has nothing on the server to attribute to; { ok: false, reason: 'no_thread' } when no valid
 * thread is stored (cleared in another tab, expired, storage unavailable).
 */
export function signalScope(control, readThread) {
  const marked = typeof control?.closest === 'function' ? control.closest('[data-run-id]') : null;
  const runId = marked?.getAttribute('data-run-id') ?? '';
  if (runId === '') return { ok: false, reason: 'no_run' };
  const stored = readThread();
  if (stored === null || typeof stored.id !== 'string') return { ok: false, reason: 'no_thread' };
  return { ok: true, threadId: stored.id, runId };
}

/**
 * Lets each signal kind leave at most once per answer (runId) for the life of the page, the rule
 * TurnMeter applies to the analytics events: a second tap on the same link of the same answer adds
 * nothing a goal needs. `send` is sendSignal (Task 9), called in the same tick, so the request is on
 * its way before a location.assign that follows; keepalive keeps it alive through the navigation,
 * and sendSignal reports a non-204 or a network failure with console.warn. A send that throws or
 * rejects anyway is reported here the same way and never reaches the click. record() returns
 * whether the signal was handed to send.
 */
export class SignalBeacon {
  #sent = new Set();
  #send;

  constructor(send) {
    this.#send = send;
  }

  record(kind, scope) {
    if (!SIGNAL_KINDS.includes(kind)) {
      console.error('[olivia] not a signal kind:', kind);
      return false;
    }
    if (scope?.ok !== true) return false;
    const key = `${kind}:${scope.runId}`;
    if (this.#sent.has(key)) return false;
    this.#sent.add(key);
    try {
      Promise.resolve(this.#send({ threadId: scope.threadId, runId: scope.runId, kind }))
        .catch((error) => console.warn('[olivia] signal not sent:', kind, error));
    } catch (error) {
      console.warn('[olivia] signal not sent:', kind, error);
    }
    return true;
  }
}

/* ── analytics (spec 7.5) ─────────────────────────────────────────────────────
   The band reports what happened as booleans on the DOM event `lab:analytics`
   ({ name, flags } on document). assets/lab-events.js alone decides whether it leaves the
   page: only the allowlisted booleans, never a page, and only with the visitor's analytics
   consent. Nothing here reads consent, and no text, amount, variant, card type or flow name
   is ever put in a flag. Each event counts once per clientTurnId; Riprova keeps the turn's
   clientTurnId, so a retried turn is one olivia_ask and one olivia_answer (its first outcome). */
export const ANALYTICS_EVENT = 'lab:analytics';
const CTA_SELECTOR = '.olivia-turn__card a[href], .olivia-turn__card button';

/** The signal one reducer step produces, or null: olivia_ask when a submit starts a turn,
 *  olivia_answer when the turn enters `done` (answered), `error` or `unavailable` (errored: the
 *  store's 500 page is a failed answer, as the v1 503 was). prev/next are TurnViews. */
export function analyticsFor(prev, input, next, hasProduct) {
  if (next.phase === prev.phase) return null;
  switch (next.phase) {
    case 'sending':
      return input.kind === 'submit' ? { name: 'olivia_ask', flags: { has_product: hasProduct === true } } : null;
    case 'done':
      return { name: 'olivia_answer', flags: { has_card: next.cards.length > 0, errored: false } };
    case 'error':
    case 'unavailable':
      return { name: 'olivia_answer', flags: { has_card: next.cards.length > 0, errored: true } };
    case 'idle':
    case 'streaming':
    case 'cooldown':
    case 'off':
    case 'capped':
      return null;
    default:
      return assertNever(next.phase);
  }
}

/** olivia_cta for a click on a link or button inside the card, or null. Cart buttons carry
 *  data-olivia-cart; every other card CTA (links, the notify form) is is_cart false. */
export function ctaSignal(target) {
  const cta = typeof target?.closest === 'function' ? target.closest(CTA_SELECTOR) : null;
  return cta ? { name: 'olivia_cta', flags: { is_cart: cta.hasAttribute('data-olivia-cart') } } : null;
}

/** Dispatches each signal at most once per event name and clientTurnId. */
export class TurnMeter {
  #seen = new Set();
  #target;

  constructor(target) {
    this.#target = target;
  }

  record(clientTurnId, signal) {
    if (!signal) return false;
    if (typeof clientTurnId !== 'string' || clientTurnId === '') {
      console.error('lab-olivia: analytics signal without a clientTurnId:', signal.name);
      return false;
    }
    const key = `${signal.name}:${clientTurnId}`;
    if (this.#seen.has(key)) return false;
    this.#seen.add(key);
    this.#target.dispatchEvent(new CustomEvent(ANALYTICS_EVENT, { detail: { name: signal.name, flags: { ...signal.flags } } }));
    return true;
  }
}

/** Measures the panel. A card CTA click counts for the exchange it sits in (article[data-turn-key]: the
 *  clientTurnId of a live exchange, run:<runId> of a restored one); the returned hook takes every reducer
 *  step of the live exchange as (turnKey, prev, input, next). */
export function meterPanel(panel) {
  const doc = panel.ownerDocument;
  const meter = new TurnMeter(doc);
  const hasProduct = doc.querySelector('lab-olivia-bar')?.hasAttribute('data-handle') === true;
  panel.addEventListener('click', (event) => {
    const signal = ctaSignal(event.target);
    if (signal === null) return;
    const turn = event.target.closest('[data-turn-key]');
    meter.record(turn?.getAttribute('data-turn-key') ?? '', signal);
  });
  return (turnKey, prev, input, next) => meter.record(turnKey, analyticsFor(prev, input, next, hasProduct));
}

/* ── wire: the panel's rules (Plan C Task 10; spec 13.1, 13.2) ───────────────────────────────────────────
   Pure tables of the conversation panel, one exhaustive switch each, read by the DOM section and held
   state by state in tools/olivia/wire.test.mjs: what the composer and the bar allow in each turn phase,
   what an exchange shows under its answer, when the answer is shown (from its first delta, D18), the
   note of a panel without a live exchange, which phases a new conversation clears, which surface shows in
   each panel state, role and focus trap per width, the 24 px auto-scroll rule and the transcript of
   GET /apps/olivia/thread. Nothing here touches the DOM, storage or the network. */

/** Width from which the panel is a side column (role complementary) instead of a sheet (role dialog). */
export const PANEL_WIDE_QUERY = '(width >= 1024px)';

/** Spec 13.1: a new answer scrolls the transcript only while the visitor sits within this many px of its end (C6). */
export const AUTO_SCROLL_SLACK_PX = 24;

const NO_NOTE = Object.freeze({ note: '', retry: null, contact: false, newConversation: false });

/**
 * The composer and the bar in one turn phase: `running` (the wait line, aria-busy), `canSend` (reduceTurn
 * takes `submit`), `input` (the field takes text), `canResume` ("Riprendi la conversazione" is offered) and
 * `status` (the bar's status line: a STRING_KEYS key, or '').
 */
export function turnTraits(phase) {
  switch (phase) {
    case 'idle':
      return { running: false, canSend: true, input: true, canResume: true, status: '' };
    case 'sending':
    case 'streaming':
      return { running: true, canSend: false, input: true, canResume: true, status: '' };
    case 'done':
    case 'error':
      return { running: false, canSend: true, input: true, canResume: true, status: '' };
    case 'cooldown':
      return { running: false, canSend: false, input: true, canResume: true, status: 'cooldown' };
    case 'off':
      return { running: false, canSend: false, input: false, canResume: false, status: 'unavailable' };
    case 'unavailable':
      return { running: false, canSend: true, input: true, canResume: true, status: 'unavailable' };
    case 'capped':
      return { running: false, canSend: false, input: false, canResume: true, status: 'session_cap' };
    default:
      return assertNever(phase);
  }
}

/** The note of a run that ended on a limit: cannot_confirm for claim_blocked, limit otherwise, with the contact link. */
export function limitNote(limitReason) {
  if (limitReason === undefined || limitReason === null) return NO_NOTE;
  return { ...NO_NOTE, note: limitReason === 'claim_blocked' ? 'cannot_confirm' : 'limit', contact: true };
}

/**
 * What the live exchange shows under its answer: `note` (a STRING_KEYS key or ''), `retry` ('retry',
 * 'reload' for PROTOCOL_MISMATCH, or null), `contact` (the contact link) and `newConversation` (the inline
 * "Nuova conversazione" of a capped thread).
 */
export function replyNote(view) {
  switch (view.phase) {
    case 'idle':
    case 'sending':
    case 'streaming':
      return NO_NOTE;
    case 'done':
      return limitNote(view.limitReason);
    case 'error':
      return { ...NO_NOTE, note: 'error', retry: view.errorCode === 'PROTOCOL_MISMATCH' ? 'reload' : 'retry', contact: true };
    case 'cooldown':
      return { ...NO_NOTE, note: 'cooldown' };
    case 'off':
    case 'unavailable':
      return { ...NO_NOTE, note: 'unavailable', contact: true };
    case 'capped':
      return { ...NO_NOTE, note: 'session_cap', newConversation: true };
    default:
      return assertNever(view.phase);
  }
}

/** True once the live exchange shows its reply: from its first delta (D18, live text that grows as it arrives; a
    retract empties it and the wait line stands in again) or once the run is over; idle shows nothing new. */
export function replyVisible(view) {
  switch (view.phase) {
    case 'idle':
    case 'sending':
      return false;
    case 'streaming':
      return view.text !== '';
    case 'done':
    case 'error':
    case 'cooldown':
    case 'off':
    case 'unavailable':
    case 'capped':
      return true;
    default:
      return assertNever(view.phase);
  }
}

/** The status line of an open panel without a live exchange (a resume that failed, a runtime that is off, a
    cooldown that outlived its question): the phase's note, or '' when there is nothing to explain. */
export function standingNote(phase) {
  switch (phase) {
    case 'idle':
    case 'sending':
    case 'streaming':
    case 'done':
      return '';
    case 'error':
      return 'error';
    case 'cooldown':
      return 'cooldown';
    case 'off':
    case 'unavailable':
      return 'unavailable';
    case 'capped':
      return 'session_cap';
    default:
      return assertNever(phase);
  }
}

/** True where reduceTurn takes `new` (C4): a new conversation, or a restored transcript, starts that phase
    over. A cooldown and an off runtime outlive the conversation; an open run is aborted first. */
export function takesNew(phase) {
  switch (phase) {
    case 'idle':
    case 'done':
    case 'error':
    case 'unavailable':
    case 'capped':
      return true;
    case 'sending':
    case 'streaming':
    case 'cooldown':
    case 'off':
      return false;
    default:
      return assertNever(phase);
  }
}

/** Which surface shows in a panel state (C5): `panel` (the panel is on screen), `surface` (data-surface),
    `bar` ('new': the field, 'resume': the resume button, 'none': the bar is hidden) and `busy` (the resume
    button waits for GET /apps/olivia/thread). */
export function panelTraits(state) {
  switch (state) {
    case 'bar_new':
      return { panel: false, surface: 'open', bar: 'new', busy: false };
    case 'bar_resume':
      return { panel: false, surface: 'open', bar: 'resume', busy: false };
    case 'resuming':
      return { panel: false, surface: 'open', bar: 'resume', busy: true };
    case 'open':
      return { panel: true, surface: 'open', bar: 'none', busy: false };
    case 'docked':
      return { panel: true, surface: 'docked', bar: 'none', busy: false };
    default:
      return assertNever(state);
  }
}

/** role of the panel (C12): a sheet under 1024 px, a side column from 1024 px. */
export function panelRole(wide) {
  return wide ? 'complementary' : 'dialog';
}

/** The sheet is modal only on the phone and only open: aria-modal, the page inert around it, Tab inside. */
export function trapsFocus(state, wide) {
  const surface = panelTraits(state);
  return !wide && surface.panel && surface.surface === 'open';
}

/** True within AUTO_SCROLL_SLACK_PX of the bottom of a scroller (an empty or hidden one included): the one
    position from which a new answer scrolls the transcript (spec 13.1). */
export function nearBottom({ scrollTop, scrollHeight, clientHeight }, slack = AUTO_SCROLL_SLACK_PX) {
  return scrollHeight - clientHeight - scrollTop <= slack;
}

/** A ThreadResponse (already checked by fetchThread) to transcript entries: one per turn, keyed by its run,
    carrying the ThreadTurn the DOM paints once. */
export function restoredEntries(response) {
  return response.turns.map((turn) => Object.freeze({ key: `run:${turn.runId}`, you: turn.you, turn }));
}

/** Restoration must respect the transport's recovery state before another authenticated read. */
export function restoreTraits(view) {
  const reload = view.phase === 'error' && view.errorCode === 'PROTOCOL_MISMATCH';
  return {
    retry: !reload && turnTraits(view.phase).canResume && view.phase !== 'cooldown' && view.phase !== 'capped',
    reload,
  };
}

/* ── Cards (Task 8; spec 4.3, 7.3, 9) ───────────────────────────────────────────────────
   renderCard(card, ctx) builds one CardSchema value out of the lab's own components
   (lab-components.css: .row, .rows, .cells, .cell, .lot, .btn, .btn-text, .arrow,
   .notice) plus the few .olivia-card__* rules of lab-olivia.css. createElement and
   textContent only: title, label, note and text come from the tools and never become
   markup. Every card href is same-origin relative (HrefSchema) and gets data-root; the
   contact link is the band's data-contact-url, already localized by Liquid.
   ctx: { strings, moneyFormat, root, cartAdd, contactUrl, checkoutUrl, lang } — strings is
   the band's data-olivia-strings object ([amount], [day], [month] placeholders), the rest
   are the band's data attributes and <html lang>.
   ctx.signal(kind, control) is the surface's signalAfter (Task 13): the cart path hands it
   cart_added after the 200 and checkout_clicked right before the navigation. */

function cardNode(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

function cardFill(template, values) {
  return template.replace(/\[(\w+)\]/g, (match, key) => (Object.hasOwn(values, key) ? String(values[key]) : match));
}

function cardDateParts(iso, strings) {
  const [year, month, day] = iso.split('-').map(Number);
  const months = strings.months_long.split(',').map((name) => name.trim());
  return { day, month: months[month - 1], year };
}

/** lab.state.ships_by for an IsoDate, the sentence snippets/lab-preorder.liquid prints. */
function cardShipsBy(iso, strings) {
  const { day, month } = cardDateParts(iso, strings);
  return cardFill(strings.ships_by, { day, month });
}

function cardDate(iso, strings) {
  const { day, month, year } = cardDateParts(iso, strings);
  return `${day} ${month} ${year}`;
}

function cardMoney(cents, ctx) {
  return formatMoney(cents, ctx.moneyFormat);
}

function cardPerLitre(cents, litres, ctx) {
  return `${cardMoney(perLitre(cents, litres), ctx)} ${ctx.strings.per_l}`;
}

function cardLitres(litres, ctx) {
  return `${new Intl.NumberFormat(ctx.lang, { maximumFractionDigits: 2 }).format(litres)} l`;
}

function cardShell(card, head) {
  const root = cardNode('div', 'olivia-card');
  root.dataset.card = card.type;
  if (head) root.append(cardNode('p', 'olivia-card__head pair', head));
  return root;
}

function cardLink(label, href) {
  const link = cardNode('a', 'btn-text', label);
  link.setAttribute('href', href);
  const arrow = cardNode('span', 'arrow', '→');
  arrow.setAttribute('aria-hidden', 'true');
  link.append(arrow);
  return link;
}

/** A label row of .rows: name (and an optional meta line) left, value in the price column. */
function cardValueRow(label, value, meta) {
  const row = cardNode('div', 'row row--noimage olivia-card__row');
  const body = cardNode('div', 'row__body');
  body.append(cardNode('p', 'row__name', label));
  if (meta) body.append(cardNode('p', 'row__meta', meta));
  row.append(body);
  if (value) row.append(cardNode('p', 'row__price', value));
  return row;
}

/** {variantId, qty, properties?} of a CartLine, without cart_summary's title and price. */
function cardLineOf({ variantId, qty, properties }) {
  return properties ? { variantId, qty, properties } : { variantId, qty };
}

/** cart-update for the header count, the bottom strip and the cart sheet (lab-cart-drawer.js
    refetches every surface for a source it does not know). A failing subscriber is logged
    and does not keep the visitor from the checkout. */
function cardPublish(cartData) {
  if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  try {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'olivia', cartData })
      .catch((error) => console.error('[olivia] cart-update subscriber failed', error));
  } catch (error) {
    console.error('[olivia] cart-update subscriber failed', error);
  }
}

/** The band's one cart path (spec 4.3, 9.1): POST {cart_add_url}.js, publish, checkout. Only
    on a tap; a second tap while the request runs does nothing. A 422 shows Shopify's
    description inside the card, any other failure lab.olivia.error_cart; no navigation. */
/** Hands a signal of the cart path to the card's surface (ctx.signal, Task 13). A missing hook or a
    failing one is logged and never keeps the visitor from the checkout, like cardPublish. */
function cardSignal(ctx, kind, control) {
  if (typeof ctx.signal !== 'function') {
    console.error('[olivia] card context without signal(); not sent:', kind);
    return;
  }
  try {
    ctx.signal(kind, control);
  } catch (error) {
    console.error('[olivia] signal failed; the cart path goes on:', kind, error);
  }
}

/** The card's one cart path (spec 4.3, 9.1, 13.6): POST {cart_add_url}.js, cart_added, publish,
    checkout_clicked, checkout. Only on a tap; a second tap while the request runs does nothing.
    A 422 shows Shopify's description inside the card, any other failure lab.olivia.error_cart;
    after a failure no signal and no navigation. */
async function cardAddToCart(button, lines, ctx) {
  if (button.getAttribute('aria-busy') === 'true') return;
  const card = button.closest('.olivia-card');
  const spinner = button.querySelector('.loading__spinner');
  card?.querySelector(':scope > .notice')?.remove();
  button.setAttribute('aria-busy', 'true');
  spinner?.classList.remove('hidden');
  let cartData;
  try {
    cartData = await addToCart(ctx.cartAdd, lines);
  } catch (error) {
    button.setAttribute('aria-busy', 'false');
    spinner?.classList.add('hidden');
    const known = error instanceof OliviaCartError;
    if (!known || error.status >= 500) console.error('[olivia] add to cart failed', error);
    const notice = cardNode('p', 'notice notice--error', (known && error.description) || ctx.strings.error_cart);
    notice.setAttribute('role', 'alert');
    card?.append(notice);
    return;
  }
  cardSignal(ctx, 'cart_added', button);
  if (typeof ctx.attribute === 'function') { try { await ctx.attribute(button, lines); } catch { /* Tracking must never interrupt checkout. */ } }
  cardPublish(cartData);
  cardSignal(ctx, 'checkout_clicked', button);
  location.assign(ctx.checkoutUrl);
}

function cardCartButton(label, lines, ctx, className = 'btn btn--inline olivia-card__cta') {
  const button = cardNode('button', className);
  button.dataset.oliviaCart = '';
  button.type = 'button';
  button.setAttribute('aria-busy', 'false');
  button.append(cardNode('span', '', label), cardNode('span', 'loading__spinner hidden'));
  const cartLines = lines.map(cardLineOf);
  button.addEventListener('click', () => {
    cardAddToCart(button, cartLines, ctx).catch((error) => console.error('[olivia] cart button failed', error));
  });
  return button;
}

function cardProductPlate(card, ctx) {
  const { strings } = ctx;
  const href = withRoot(ctx.root, card.href);
  const root = cardShell(card);
  const row = cardNode('div', 'row row--product row--noimage olivia-card__row');
  const body = cardNode('div', 'row__body');
  const name = cardNode('a', 'row__name t-display-s', card.title);
  name.setAttribute('href', href);
  body.append(name, cardNode('p', 'row__format', card.variantTitle));
  if (card.shipsBy) body.append(cardNode('p', 'row__meta', cardShipsBy(card.shipsBy, strings)));
  const price = cardNode('p', 'row__price');
  price.append(cardNode('span', '', cardMoney(card.price.cents, ctx)), cardNode('span', 'row__meta', cardPerLitre(card.price.cents, card.litres, ctx)));
  row.append(body, price);
  if (card.availability === 'sold_out') row.append(cardNode('p', 'row__state', strings.sold_out));
  const action = cardNode('div', 'row__action');
  switch (card.cta) {
    case 'add_to_cart':
      action.append(cardCartButton(card.availability === 'preorder' ? strings.preorder : strings.add_to_cart, [card.line], ctx));
      break;
    case 'view':
      action.append(cardLink(strings.see, href));
      break;
    case 'notify':
      action.append(cardLink(strings.notify, href));
      break;
    default:
      assertNever(card.cta);
  }
  row.append(action);
  root.append(row);
  return root;
}

function cardPriceRow(card, ctx) {
  const root = cardShell(card, ctx.strings.price);
  const rows = cardNode('div', 'rows');
  for (const item of card.rows) {
    const meta = item.litres === undefined ? undefined : `${cardLitres(item.litres, ctx)} · ${cardPerLitre(item.price.cents, item.litres, ctx)}`;
    rows.append(cardValueRow(item.label, cardMoney(item.price.cents, ctx), meta));
  }
  root.append(rows);
  if (card.note) root.append(cardNode('p', 'row__meta', card.note));
  return root;
}

function cardBandRow(card, ctx) {
  const { strings } = ctx;
  const root = cardShell(card, strings.shipping);
  const rows = cardNode('div', 'rows');
  const country = new Intl.DisplayNames([ctx.lang], { type: 'region' }).of(card.country) ?? card.country;
  if (card.price) rows.append(cardValueRow(`${strings.shipping_cost} · ${country}`, card.price.cents === 0 ? strings.free : cardMoney(card.price.cents, ctx)));
  if (card.freeFrom) rows.append(cardValueRow(cardFill(strings.free_from, { amount: cardMoney(card.freeFrom.cents, ctx) })));
  if (card.shipsBy) rows.append(cardValueRow(cardShipsBy(card.shipsBy, strings)));
  root.append(rows);
  if (card.lines?.length) root.append(cardCartButton(strings.checkout, card.lines, ctx));
  return root;
}

function cardCartSummary(card, ctx) {
  const { strings } = ctx;
  const root = cardShell(card);
  const rows = cardNode('div', 'rows');
  for (const line of card.lines) rows.append(cardValueRow(`${line.qty} × ${line.title}`, cardMoney(line.price.cents * line.qty, ctx)));
  const total = cardNode('p', 'olivia-card__total');
  total.append(cardNode('span', '', strings.subtotal), cardNode('span', '', cardMoney(card.subtotal.cents, ctx)));
  root.append(rows, total);
  if (card.shipping) root.append(cardNode('p', 'row__meta', `${strings.shipping_cost} · ${card.shipping.cents === 0 ? strings.free : cardMoney(card.shipping.cents, ctx)}`));
  if (card.gapToFree && card.gapToFree.cents > 0) root.append(cardNode('p', 'row__meta', cardFill(strings.gap_to_free, { amount: cardMoney(card.gapToFree.cents, ctx) })));
  if (card.shipsBy) root.append(cardNode('p', 'row__meta', cardShipsBy(card.shipsBy, strings)));
  root.append(cardCartButton(strings.checkout, card.lines, ctx));
  return root;
}

function cardLotInstrument(card, ctx) {
  const { strings } = ctx;
  const root = cardShell(card);
  const href = withRoot(ctx.root, card.href);
  if (!card.lot) {
    root.append(cardLink(strings.lot_lookup, href));
    return root;
  }
  const fact = (label, value, className) => {
    const row = cardNode('p', 'lot__row');
    row.append(cardNode('span', 'lot__label pair', label), cardNode('span', className, value));
    return row;
  };
  const lot = cardNode('div', 'lot');
  lot.append(
    fact(strings.lot, card.lot.code, 'lot__code mono'),
    fact(strings.cultivar, card.lot.cultivar),
    fact(strings.field, card.lot.field),
    fact(strings.milling, cardDate(card.lot.milledOn, strings)),
    fact(strings.best_before, cardDate(card.lot.bestBefore, strings)),
  );
  root.append(lot, cardLink(strings.see, href));
  return root;
}

function cardLinkRow(card, ctx) {
  const root = cardShell(card);
  const rows = cardNode('div', 'rows');
  for (const link of card.links) {
    const row = cardNode('div', 'row row--link olivia-card__row');
    const body = cardNode('div', 'row__body');
    body.append(cardLink(link.label, withRoot(ctx.root, link.href)));
    if (link.text) body.append(cardNode('p', 'row__meta', link.text));
    row.append(body);
    rows.append(row);
  }
  root.append(rows);
  return root;
}

function cardAvvisami(card, ctx) {
  const root = cardShell(card);
  const row = cardNode('div', 'row row--product row--noimage olivia-card__row');
  const body = cardNode('div', 'row__body');
  body.append(cardNode('p', 'row__name t-display-s', card.title), cardNode('p', 'row__format', card.variantTitle));
  const action = cardNode('div', 'row__action');
  action.append(cardLink(ctx.strings.notify, withRoot(ctx.root, `/products/${card.handle}?variant=${card.variantId}`)));
  row.append(body, action);
  root.append(row);
  return root;
}

function cardContactRow(card, ctx) {
  const root = cardShell(card);
  root.dataset.reason = card.reason;
  root.append(cardLink(ctx.strings.contact, ctx.contactUrl));
  return root;
}

function cardChipRow(card, ctx) {
  const root = cardShell(card, ctx.strings.add_to_cart);
  const cells = cardNode('div', 'cells cells--switch');
  for (const option of card.options) {
    const cell = cardNode('div', 'cell');
    const label = `${option.label} · ${cardMoney(option.price.cents, ctx)} · ${cardPerLitre(option.price.cents, option.litres, ctx)}`;
    cell.append(cardCartButton(label, [option.line], ctx, 'cell__word olivia-card__cta'));
    cells.append(cell);
  }
  root.append(cells);
  return root;
}

/** The Card each rendered card root was built from (renderCard), for the signal of a click on it
    (Task 13). A WeakMap: a root removed with its exchange takes its entry along. */
const CARD_VALUES = new WeakMap();

/** The Card of the .olivia-card root that holds `node`, or null outside a card renderCard built. */
function cardValueOf(node) {
  const root = typeof node?.closest === 'function' ? node.closest('.olivia-card') : null;
  return root === null ? null : CARD_VALUES.get(root) ?? null;
}

export function renderCard(card, ctx) {
  const fragment = document.createDocumentFragment();
  switch (card.type) {
    case 'product_plate':
      fragment.append(cardProductPlate(card, ctx));
      break;
    case 'price_row':
      fragment.append(cardPriceRow(card, ctx));
      break;
    case 'band_row':
      fragment.append(cardBandRow(card, ctx));
      break;
    case 'cart_summary':
      fragment.append(cardCartSummary(card, ctx));
      break;
    case 'lot_instrument':
      fragment.append(cardLotInstrument(card, ctx));
      break;
    case 'link_row':
      fragment.append(cardLinkRow(card, ctx));
      break;
    case 'avvisami_field':
      fragment.append(cardAvvisami(card, ctx));
      break;
    case 'contact_row':
      fragment.append(cardContactRow(card, ctx));
      break;
    case 'chip_row':
      fragment.append(cardChipRow(card, ctx));
      break;
    default:
      assertNever(card);
  }
  // the Card this root was built from, for the signal of a click on it (Task 13)
  const root = fragment.firstElementChild;
  if (root !== null) CARD_VALUES.set(root, card);
  return fragment;
}

/** Spec 7.3: one card is visible, the last valid one of the run. A value that is not a
    CardSchema card is skipped with a warning; the answer text is untouched. */
function lastValidCard(cards) {
  for (let index = cards.length - 1; index >= 0; index -= 1) {
    if (isCard(cards[index])) return cards[index];
    console.warn('[olivia] card skipped: not a valid card', cards[index]);
  }
  return null;
}

/* ── motion (Plan C Task 12; spec 13.3, contract C13) ─────────────────────────────────────
   Every change of what the visitor sees of OlivIA is a same-document view transition in the
   language of /blogs/news: there assets/lab-vt.js names the one row being followed at
   pointerdown and sections/main-article.liquid names the destination title; here
   runTransition() (DOM section) names the roles of the old state just before
   document.startViewTransition(), names those of the new state inside its update, and removes
   every name on `finished`. A named element is its own stacking context (2720 against 1280 ms
   of main-thread work for one scroll of /blogs/news at 390, CPU 4x: assets/lab-vt.js), so no
   name stays on the page between two changes. The animations are the keyframes and tokens of
   assets/lab-motion.css, applied by the motion layer of assets/lab-olivia.css. One table per
   layout (settings.olivia_layout): the band replaces the last exchange in place, the panel
   keeps a transcript. Pure data and functions: tools/olivia/motion.test.mjs imports them. */

export const VT_NAMES = Object.freeze({
  panel: 'olivia-panel',
  band: 'olivia-band',
  composer: 'olivia-composer',
  line: 'olivia-line',
  turn: 'olivia-turn',
  transcript: 'olivia-transcript',
});

export const TRANSITION_KINDS = Object.freeze(['first_send', 'resume', 'expand', 'reduce', 'close', 'turn', 'answer', 'new']);

// The places of the C12 markup a transition names; runTransition() finds them (roleElement).
// surface is the host of the layout (#olivia-band or #olivia-panel); barEntry is whichever of
// barResume and barField the bar shows after Chiudi (the panel: the band's bar keeps the field).
export const VT_ROLES = Object.freeze([
  'barField', 'barInput', 'barResume', 'barEntry', 'surface', 'composer', 'firstLine', 'lastTurn', 'lastReply', 'transcript',
]);

const vtEntry = (pairs, onlyOld, onlyNew) =>
  Object.freeze({
    pairs: Object.freeze(pairs.map((pair) => Object.freeze(pair))),
    onlyOld: Object.freeze(onlyOld.map((entry) => Object.freeze(entry))),
    onlyNew: Object.freeze(onlyNew.map((entry) => Object.freeze(entry))),
  });

// layout -> kind -> { pairs: [[oldRole, newRole, nameKey]], onlyOld: [[role, nameKey]], onlyNew: [[role, nameKey]] }.
// The band (default): the bar's field and the typed question morph into the field inside the band and
// the question line while the band rises; a send morphs the old exchange into the new one in place
// (the band and the field hold still as pairs); the answer rises under the question when it begins;
// Chiudi and Nuova conversazione fade the band and sink the field back into the bar. The panel: the
// C13 table plus one pair, recorded in spec 13.14: in turn, answer and new the panel is on screen
// before and after, so it is named as a pair that holds still. Unnamed it would belong to the root
// snapshot, and every element the page names for good (media-<id> and lab-price on a product page)
// would be drawn over it for the whole transition. The band is a still pair in turn and answer for
// the same reason.
export const TRANSITIONS = Object.freeze({
  band: Object.freeze({
    first_send: vtEntry([['barField', 'composer', 'composer'], ['barInput', 'firstLine', 'line']], [], [['surface', 'band']]),
    resume: vtEntry([['barResume', 'composer', 'composer']], [], [['surface', 'band']]),
    turn: vtEntry([['surface', 'surface', 'band'], ['composer', 'composer', 'composer'], ['lastTurn', 'lastTurn', 'turn']], [], []),
    answer: vtEntry([['surface', 'surface', 'band'], ['composer', 'composer', 'composer']], [], [['lastReply', 'turn']]),
    new: vtEntry([['composer', 'barField', 'composer']], [['surface', 'band']], []),
    close: vtEntry([['composer', 'barField', 'composer']], [['surface', 'band']], []),
  }),
  panel: Object.freeze({
    first_send: vtEntry([['barField', 'composer', 'composer'], ['barInput', 'firstLine', 'line']], [], [['surface', 'panel']]),
    resume: vtEntry([['barResume', 'composer', 'composer']], [], [['surface', 'panel']]),
    expand: vtEntry([['composer', 'composer', 'composer']], [], [['surface', 'panel']]),
    reduce: vtEntry([['composer', 'composer', 'composer']], [['surface', 'panel']], []),
    close: vtEntry([['composer', 'barEntry', 'composer']], [['surface', 'panel']], []),
    turn: vtEntry([['surface', 'surface', 'panel']], [], [['lastTurn', 'turn']]),
    answer: vtEntry([['surface', 'surface', 'panel']], [], [['lastReply', 'turn']]),
    new: vtEntry([['surface', 'surface', 'panel']], [['transcript', 'transcript']], []),
  }),
});

// D17: the first send morphs on every pointer. Task 16 tries it on a real iPhone; if focusing
// #olivia-c inside the transition's update closes the keyboard, this becomes true and a coarse
// pointer gets the first send as an instant change.
export const FIRST_SEND_COARSE_INSTANT = false;

export class UnknownTransitionError extends Error {
  constructor(layout, kind) {
    super(`unknown transition: ${JSON.stringify(layout)} ${JSON.stringify(kind)}`);
    this.name = 'UnknownTransitionError';
    this.layout = layout;
    this.kind = kind;
  }
}

/** The names of one transition of a layout by state, as [role, name]: `old` is named before
    document.startViewTransition(), `new` inside its update. A kind the layout never plays (reduce
    and expand on the band) is an UnknownTransitionError. */
export function transitionPlan(layout, kind) {
  if (!LAYOUTS.includes(layout) || !Object.hasOwn(TRANSITIONS[layout], kind)) throw new UnknownTransitionError(layout, kind);
  const { pairs, onlyOld, onlyNew } = TRANSITIONS[layout][kind];
  const named = (role, key) => Object.freeze([role, VT_NAMES[key]]);
  return Object.freeze({
    layout,
    kind,
    old: Object.freeze([...pairs.map(([role, , key]) => named(role, key)), ...onlyOld.map(([role, key]) => named(role, key))]),
    new: Object.freeze([...pairs.map(([, role, key]) => named(role, key)), ...onlyNew.map(([role, key]) => named(role, key))]),
  });
}

/** False wherever the change must be instant: no View Transitions, reduced motion, the theme
    editor, and the first send on a coarse pointer while FIRST_SEND_COARSE_INSTANT. */
export function shouldAnimate({ supportsViewTransitions, reducedMotion, designMode, coarse, kind }) {
  if (!TRANSITION_KINDS.includes(kind)) throw new UnknownTransitionError(null, kind);
  if (!supportsViewTransitions || reducedMotion || designMode) return false;
  if (kind === 'first_send' && coarse) return !FIRST_SEND_COARSE_INSTANT;
  return true;
}

/* ── DOM: <lab-olivia-bar> and <lab-olivia-panel> (Plan C Task 10; spec 13.1, 13.2, 13.5) ────────────────
   The panel is one of two layouts (settings.olivia_layout): <lab-olivia-band> below reuses its machinery. Two machines decide everything: reducePanel (where the
   conversation is: bar, open, docked) and reduceTurn (the generated copy above: the run of the latest
   question). The state changes first, synchronously; then change(kind, paint) redraws the DOM from the
   state through render(), which reads the exhaustive tables of the wire section (panelTraits, turnTraits,
   replyNote, standingNote). change() is the seam of the in-page View Transitions of Task 12; here it
   paints at once. The transcript is this.log, one entry per exchange: restored from GET
   /apps/olivia/thread (painted once) or the live one (painted from the turn view). The answer grows
   delta by delta as the server streams it (D18); nothing moves on a timer, the one timer is the Retry-After of a 429 (a state
   timer). Nothing touches the network and nothing is written to storage at load: the thread id is only
   read from localStorage (C6), it is written by a voluntary send, and the transcript is fetched only by
   "Riprendi la conversazione". olivia:off is written after a RUNTIME_OFF answer and read at load, so a
   closed runtime stays closed for the tab. The elements are defined once the document is active, so a
   speculation-rules prerender never upgrades them. Node imports this module for the wire tests, so
   everything below sits behind the customElements check. */
if (typeof customElements !== 'undefined') {
  // ── motion: runTransition (Task 12; spec 13.3, C13) ──────────────────────────────────────
  const MOTION_QUERY = Object.freeze({ reduced: '(prefers-reduced-motion: reduce)', coarse: '(pointer: coarse)' });
  const VT_CLASS = 'olivia-vt';
  const designMode = () =>
    document.documentElement.classList.contains('shopify-design-mode') || Boolean(window.Shopify?.designMode);

  // Shopify Forms owns an open shadow root. Its modal already has the correct stacking
  // order; a named View Transition snapshot would nevertheless paint above that modal.
  const FORMS_HOST = 'shopify-forms-embed';
  function formsModalOpen() {
    return [...document.querySelectorAll(FORMS_HOST)].some((host) =>
      host.checkVisibility?.() !== false && [...(host.shadowRoot?.querySelectorAll('[role="dialog"][aria-modal="true"]') ?? [])]
        .some((dialog) => (dialog.checkVisibility?.() ?? getComputedStyle(dialog).visibility !== 'hidden') && dialog.getClientRects().length > 0));
  }

  function focusOlivia(element, options) {
    if (!formsModalOpen() && !document.querySelector('dialog[open]') && !document.querySelector('lab-header')?.isOpen?.()) element?.focus(options);
  }

  /** The element of a VT_ROLES role in the C12 markup of `host` (#olivia-band or #olivia-panel), or
      null when it is absent or not rendered. */
  function roleElement(role, host) {
    const turns = host.querySelectorAll('article.olivia-turn');
    const last = turns.length > 0 ? turns[turns.length - 1] : null;
    let element = null;
    switch (role) {
      case 'barField':
        element = document.querySelector('lab-olivia-bar .olivia-bar__field');
        break;
      case 'barInput':
        element = document.getElementById('olivia-q');
        break;
      case 'barResume':
        element = document.querySelector('lab-olivia-bar .olivia-bar__resume');
        break;
      case 'barEntry':
        return roleElement('barResume', host) ?? roleElement('barField', host);
      case 'surface':
        element = host;
        break;
      case 'composer':
        element = host.querySelector('.olivia-composer');
        break;
      case 'firstLine':
        element = turns.length > 0 ? turns[0].querySelector('.olivia-turn__you') : null;
        break;
      case 'lastTurn':
        element = last;
        break;
      case 'lastReply':
        element = last?.querySelector('.olivia-turn__reply') ?? null;
        break;
      case 'transcript':
        element = host.querySelector('.olivia-panel__transcript, .olivia-band__exchange');
        break;
      default:
        return assertNever(role);
    }
    return element !== null && element.checkVisibility() ? element : null;
  }

  /** The transition in progress: { kind, transition, named, updates, updated, failure }. */
  let activeTransition = null;

  function nameRoles(record, host, entries) {
    for (const [role, name] of entries) {
      const element = roleElement(role, host);
      if (element === null) continue; // not on screen in this state: its partner enters or leaves alone
      element.style.viewTransitionName = name;
      record.named.push(element);
    }
  }

  function clearNames(record) {
    for (const element of record.named) element.style.removeProperty('view-transition-name');
    record.named = [];
  }

  function endTransition(record) {
    record.formsWatch?.disconnect();
    if (activeTransition !== record) return; // a newer transition took the names and html over
    clearNames(record);
    activeTransition = null;
    document.documentElement.classList.remove(VT_CLASS);
    delete document.documentElement.dataset.oliviaVt;
  }

  function skipForForms(record) {
    if (record.cancelled) return;
    record.cancelled = true;
    record.formsWatch?.disconnect();
    clearNames(record);
    record.transition?.skipTransition();
    document.documentElement.classList.remove(VT_CLASS);
    delete document.documentElement.dataset.oliviaVt;
  }

  /** Observe only for the short life of a transition, including a Forms embed added later. */
  function watchForms(record) {
    const roots = new WeakSet();
    const check = () => {
      if (activeTransition !== record || record.cancelled) return;
      for (const host of document.querySelectorAll(FORMS_HOST)) {
        if (!host.shadowRoot || roots.has(host.shadowRoot)) continue;
        roots.add(host.shadowRoot);
        record.formsWatch.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true });
      }
      if (formsModalOpen()) skipForForms(record);
    };
    record.formsWatch = new MutationObserver(check);
    record.formsWatch.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
    customElements.whenDefined(FORMS_HOST).then(check);
    check();
  }

  /**
   * Paints `update` (state and focus already decided by the machines) of the surface `host` of
   * `layout` as the transition `kind`, or at once. Spec 13.3, C13:
   * - kind null, no View Transitions, reduced motion, the theme editor, or a coarse first send
   *   while FIRST_SEND_COARSE_INSTANT: update() runs now and nothing is named;
   * - a transition whose update has not run yet takes `update` too: its update paints the latest
   *   state, so two inputs of one frame are one transition;
   * - a transition already animating is cut with skipTransition(), never queued: its names go
   *   first, then the new one names its old roles. A kind null while one animates paints at once
   *   (D18: the live text grows inside the answer that rises).
   * Names exist from just before document.startViewTransition() until `finished`.
   */
  function runTransition(host, layout, kind, update) {
    const running = activeTransition;
    if (formsModalOpen()) {
      if (running !== null) skipForForms(running);
      // A skipped transition still runs its update callback; keep its queued paints together.
      if (running !== null && !running.updated) running.updates.push(update);
      else update();
      return;
    }
    if (running !== null && !running.updated) {
      running.updates.push(update);
      return;
    }
    const animate =
      kind !== null &&
      shouldAnimate({
        supportsViewTransitions: typeof document.startViewTransition === 'function',
        reducedMotion: window.matchMedia(MOTION_QUERY.reduced).matches,
        designMode: designMode(),
        coarse: window.matchMedia(MOTION_QUERY.coarse).matches,
        kind,
      });
    if (!animate) {
      update();
      return;
    }
    if (running !== null) {
      clearNames(running);
      activeTransition = null;
      running.transition.skipTransition();
    }
    const plan = transitionPlan(layout, kind);
    const record = { kind, transition: null, named: [], updates: [update], updated: false, failure: null };
    const root = document.documentElement;
    root.classList.add(VT_CLASS);
    root.dataset.oliviaVt = kind;
    nameRoles(record, host, plan.old);
    activeTransition = record;
    record.transition = document.startViewTransition(() => {
      clearNames(record);
      record.updated = true;
      try {
        for (const step of record.updates) step();
      } catch (error) {
        record.failure = error; // reported once, by the `finished` handler
        throw error;
      }
      if (!record.cancelled && !formsModalOpen()) nameRoles(record, host, plan.new);
      else skipForForms(record);
    });
    watchForms(record);
    record.transition.ready.then(null, (error) => {
      if (error === record.failure) return; // the update failed: `finished` reports it
      if (error.name === 'AbortError') return; // cut by a newer transition; the update ran anyway
      console.error(`[olivia] view transition ${kind} not animated: ${error.name}`);
    });
    record.transition.finished.then(
      () => endTransition(record),
      (error) => {
        endTransition(record);
        console.error(`[olivia] view transition ${kind} update failed: ${error.name}`, error);
      },
    );
  }

  const ABORTED = Object.freeze({ kind: 'http', status: 0, json: false, code: 'ABORTED' });
  const OFF_FOR_TAB = Object.freeze({ kind: 'http', status: 403, json: true, code: 'RUNTIME_OFF' });
  const NO_CARDS = Object.freeze([]);

  /** The stored thread (C6) at the moment of a click, for the ids of a signal (Task 13). A storage the
      browser refuses to open is reported and reads as no thread; readStoredThread reports the rest. */
  function storedThreadNow() {
    try {
      return readStoredThread(window.localStorage, Date.now());
    } catch (error) {
      console.warn('[olivia] localStorage is not readable; no signal', error);
      return null;
    }
  }
  const NO_SUGGESTIONS = Object.freeze([]);
  const NOT_PAGE = 'script, style, link, template';

  let stringsCache = null;
  /** The panel's data-olivia-strings JSON, parsed once; a missing key reads '' and is reported. */
  function oliviaStrings() {
    if (stringsCache !== null) return stringsCache;
    const node = document.querySelector('script[data-olivia-strings]');
    let parsed = null;
    if (node === null) {
      console.error('[olivia] script[data-olivia-strings] is missing');
    } else {
      try {
        parsed = JSON.parse(node.textContent || 'null');
      } catch (error) {
        console.error('[olivia] data-olivia-strings is not JSON', error);
      }
    }
    const source = parsed !== null && typeof parsed === 'object' ? parsed : {};
    const strings = {};
    const missing = [];
    for (const key of STRING_KEYS) {
      if (typeof source[key] === 'string') {
        strings[key] = source[key];
      } else {
        strings[key] = '';
        missing.push(key);
      }
    }
    if (missing.length > 0) console.warn(`[olivia] strings missing: ${missing.join(', ')}`);
    stringsCache = Object.freeze(strings);
    return stringsCache;
  }

  /** window.localStorage or window.sessionStorage, or null where the browser refuses storage (reported). */
  function storageOf(name) {
    try {
      return window[name];
    } catch (error) {
      console.warn(`[olivia] ${name} is not available`, error);
      return null;
    }
  }

  /** True when this tab already met a RUNTIME_OFF answer (sessionStorage olivia:off = '1', C6). */
  function readOff(session) {
    if (session === null) return false;
    try {
      return session.getItem(OFF_KEY) === '1';
    } catch (error) {
      console.warn('[olivia] sessionStorage is not readable', error);
      return false;
    }
  }

  function writeOff(session) {
    if (session === null) return;
    try {
      session.setItem(OFF_KEY, '1');
    } catch (error) {
      console.warn('[olivia] sessionStorage is not writable', error);
    }
  }

  /** The RUN_ERROR the theme writes itself when a started stream stops without RUN_FINISHED or RUN_ERROR. */
  const streamEnded = (run, code) => ({ type: 'RUN_ERROR', seq: run.lastSeq + 1, message: 'stream ended', code });

  /** The consent dialog stays reachable over the sheet: it is never made inert. */
  const holdsConsent = (element) => element.id === 'cookie-consent-banner' || element.querySelector('#cookie-consent-banner') !== null;

  /* ── Panel placement without anchor positioning (plan C Task 11; spec 13.1) ──────────────
     assets/lab-olivia.css hangs the open panel from the chrome's bottom edge by anchor
     positioning (anchor-name --olivia-chrome on .lab-header-section, position-anchor on the
     panel). Where the engine has none, the same edge is measured here, as placeUnderChrome()
     in assets/lab-unfold.js measures it for the label, and written as --olivia-chrome-bottom
     on the panel: whenever the panel is shown or changes surface (its hidden, data-panel and
     data-surface attributes, watched by a MutationObserver, so no way of opening it needs a
     call of its own), when a page scroll ends, and at a resize, which also covers the 1024
     breakpoint. Events only, no timer and no frame loop: during a scroll the panel keeps the
     last edge and scrollend puts it back under the chrome ('scroll' where scrollend is
     missing). Where anchor positioning exists, nothing here runs. */
  const ANCHORED = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('anchor-name: --a');
  const PAGE_SCROLL_END = 'onscrollend' in window ? 'scrollend' : 'scroll';

  /** Writes the chrome's bottom edge, in viewport pixels, as --olivia-chrome-bottom on `panel`. */
  function placePanel(panel) {
    const chrome = document.querySelector('.olivia-dock') ?? document.querySelector('.lab-header-section');
    const bottom = chrome === null ? 0 : Math.max(0, Math.round(chrome.getBoundingClientRect().bottom));
    panel.style.setProperty('--olivia-chrome-bottom', `${bottom}px`);
  }

  /** Keeps placePanel() current while `panel` is shown, until `signal` aborts; a no-op with anchor positioning. */
  function followChrome(panel, signal) {
    if (ANCHORED) return;
    const place = () => {
      if (!panel.hidden) placePanel(panel);
    };
    const observer = new MutationObserver(place);
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden', 'data-panel', 'data-surface'] });
    signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    window.addEventListener(PAGE_SCROLL_END, place, { signal, passive: true });
    window.addEventListener('resize', place, { signal, passive: true });
    place();
  }
  /* ── end of panel placement ── */

  const INPUT_EXAMPLES = {
    it: ["Quale olio fa per me?", "Quanto costa la spedizione?", "Da dove vengono le olive?"],
    en: ["Which oil is right for me?", "How much is shipping?", "Where do the olives come from?"],
    fr: ["Quelle huile me convient ?", "Combien coûte la livraison ?", "D’où viennent les olives ?"],
    de: ["Welches Öl passt zu mir?", "Was kostet der Versand?", "Woher kommen die Oliven?"],
  };
  const inputQuestions = new Map();
  function loadInputQuestions(locale) {
    if (inputQuestions.has(locale)) return inputQuestions.get(locale);
    const promise = fetch(`/apps/olivia/suggestions?locale=${encodeURIComponent(locale)}`, {
      signal: AbortSignal.timeout(4000), headers: { accept: 'application/json' },
    }).then(async response => {
      if (!response.ok) return [];
      const body = await response.json();
      if (body.locale !== locale || !Array.isArray(body.questions) || body.questions.length > 4) return [];
      if (!body.questions.every(q => q && INTENT_IDS.includes(q.intent) && typeof q.text === 'string' && q.text.length > 0 && q.text.length <= 200)) return [];
      return [...new Set(body.questions.map(q => q.text))];
    }).catch(() => []);
    inputQuestions.set(locale, promise);
    return promise;
  }

  /** Idle examples stay decorative; choosing a complete question fills a draft, never sends. */
  function animateInputHint(input, host, signal) {
    const locale = mapLocale(document.querySelector('lab-olivia-bar')?.dataset.locale ?? document.documentElement.lang);
    const original = input.placeholder;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const examples = input.id === 'olivia-q' ? document.createElement('div') : null;
    if (examples) {
      examples.className = 'olivia-bar__examples';
      examples.setAttribute('role', 'group');
      examples.setAttribute('aria-label', oliviaStrings().example_questions);
      examples.hidden = true;
      input.closest('.olivia-bar__field').append(examples);
    }
    let questions = INPUT_EXAMPLES[locale];
    let pendingQuestions = null;
    let index = 0;
    let position = 0;
    let deleting = false;
    let timer = 0;
    let visible = typeof IntersectionObserver === 'undefined';
    let disposed = false;
    let composing = false;
    let dismissed = false;
    const clear = () => { window.clearTimeout(timer); timer = 0; };
    const focused = () => host.contains(document.activeElement);
    const editorial = () => host.dataset.layout === 'band' && document.getElementById('olivia-welcome') !== null && window.matchMedia('(min-width: 1024px) and (min-height: 640px)').matches;
    const staticPrompt = () => host.dataset.layout === 'band';
    const introductory = () => examples === null || host.dataset.panel === 'bar_new';
    const blocked = () => formsModalOpen() || document.querySelector('dialog[open]') !== null || Boolean(document.querySelector('lab-header')?.isOpen?.());
    const active = () => !disposed && visible && !document.hidden && !input.disabled && input.value === '' && !composing && !focused() && introductory() && !staticPrompt();
    const schedule = delay => { clear(); timer = window.setTimeout(tick, delay); };
    function renderExamples() {
      if (!examples) return;
      examples.replaceChildren(...questions.map(question => {
        const button = document.createElement('button');
        button.className = 'olivia-bar__example';
        button.type = 'button';
        button.textContent = question;
        // A pointer choice keeps the input focused, avoiding a blur that closes the list
        // before click. Keyboard users can reach every real button with Tab.
        button.addEventListener('pointerdown', event => { if (event.button === 0) event.preventDefault(); }, { signal });
        button.addEventListener('click', () => {
          if (blocked() || input.disabled || composing) return;
          input.value = question;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          focusOlivia(input, { preventScroll: true });
        }, { signal });
        return button;
      }));
    }
    function applyPendingQuestions() {
      if (disposed || pendingQuestions === null || focused()) return;
      questions = pendingQuestions; pendingQuestions = null; index = 0;
      renderExamples();
    }
    function tick() {
      timer = 0;
      if (!active() || reduced.matches) return;
      const characters = Array.from(questions[index]);
      position += deleting ? -1 : 1;
      input.placeholder = characters.slice(0, position).join('');
      if (!deleting && position >= characters.length) { deleting = true; schedule(3500); }
      else if (deleting && position <= 0) { deleting = false; index = (index + 1) % questions.length; schedule(500); }
      else schedule(deleting ? 22 : 55);
    }
    function fitExamples() {
      if (!examples || examples.hidden || disposed) return;
      const viewport = window.visualViewport;
      const strip = document.querySelector('lab-bottom-strip');
      const stripHeight = strip && getComputedStyle(strip).display !== 'none' ? strip.getBoundingClientRect().height : 0;
      const bottom = (viewport ? viewport.offsetTop + viewport.height : innerHeight) - stripHeight - 8;
      let space = bottom - examples.getBoundingClientRect().top;
      // If the first touch target cannot fit, reveal only the extra room it needs.
      // The dock stops at the navbar; longer lists scroll within the remaining space.
      if (space < 54 && host.dataset.layout === 'band') {
        const dock = host.closest('lab-olivia-dock');
        const pin = parseFloat(dock?.style.getPropertyValue('--olivia-dock-top')) || 0;
        const room = Math.max(0, (dock?.getBoundingClientRect().top ?? pin) - pin);
        if (room > 0) window.scrollBy({ top: Math.min(54 - space, room), behavior: 'instant' });
        space = bottom - examples.getBoundingClientRect().top;
      }
      examples.style.setProperty('--olivia-example-space', `${Math.max(0, space)}px`);
    }
    function reset() {
      if (disposed) return;
      clear(); position = 0; deleting = false;
      // The storefront's writing prompt stays complete on every screen. Questions
      // appear separately on focus; the alternative panel keeps its idle hints.
      input.placeholder = input.value === '' && introductory() && !staticPrompt() ? questions[index] : original;
      if (examples) {
        const wasHidden = examples.hidden;
        examples.hidden = editorial() || dismissed || !visible || document.hidden || input.disabled || input.value !== '' || composing || !focused() || host.dataset.panel !== 'bar_new' || blocked();
        if (wasHidden && !examples.hidden) examples.scrollTop = 0;
        fitExamples();
      }
      if (active() && !reduced.matches) { input.placeholder = ''; schedule(500); }
    }
    const visibility = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? false; reset();
    });
    visibility?.observe(input);
    const observer = new MutationObserver(reset);
    observer.observe(input, { attributes: true, attributeFilter: ['disabled'] });
    observer.observe(host, { attributes: true, attributeFilter: ['hidden', 'data-panel', 'data-state'] });
    host.addEventListener('focusin', event => {
      if (event.target === input) dismissed = false;
      reset();
    }, { signal });
    host.addEventListener('focusout', event => {
      if (event.relatedTarget instanceof Node && host.contains(event.relatedTarget)) return;
      queueMicrotask(() => { applyPendingQuestions(); reset(); });
    }, { signal });
    input.addEventListener('input', () => { dismissed = false; reset(); }, { signal });
    input.addEventListener('compositionstart', () => { composing = true; reset(); }, { signal });
    input.addEventListener('compositionend', () => { composing = false; reset(); }, { signal });
    host.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing || composing || !examples || examples.hidden || blocked()) return;
      event.preventDefault(); event.stopPropagation();
      if (examples.contains(document.activeElement)) focusOlivia(input, { preventScroll: true });
      dismissed = true; reset();
    }, { signal });
    document.addEventListener('pointerdown', event => {
      if (examples && !host.contains(event.target)) { dismissed = true; reset(); }
    }, { signal });
    document.addEventListener('visibilitychange', reset, { signal });
    window.addEventListener('resize', reset, { signal });
    window.addEventListener('scroll', fitExamples, { signal, passive: true });
    window.visualViewport?.addEventListener('resize', () => requestAnimationFrame(reset), { signal });
    window.visualViewport?.addEventListener('scroll', fitExamples, { signal, passive: true });
    reduced.addEventListener('change', reset, { signal });
    signal.addEventListener('abort', () => {
      disposed = true; clear(); observer.disconnect(); visibility?.disconnect(); examples?.remove(); input.placeholder = original;
    }, { once: true });
    renderExamples();
    reset();
    loadInputQuestions(locale).then(ranked => {
      if (disposed || ranked.length === 0) return;
      pendingQuestions = ranked; applyPendingQuestions(); reset();
    });
  }

  class LabOliviaPanel extends HTMLElement {
    connectedCallback() {
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      followChrome(this, signal);
      this.local = storageOf('localStorage');
      this.session = storageOf('sessionStorage');
      const stored = this.local === null ? null : readStoredThread(this.local, Date.now());
      this.threadId = stored?.token ? stored.id : null;
      this.sessionToken = stored?.token ?? null; // read by the signals of Task 13
      this.expiredThread = stored !== null && 'expired' in stored;
      this.panel = initialPanel(false); // no resume bar (owner, 2026-10-08): a stored id only continues the thread on the next send
      this.view = readOff(this.session) ? fromHttp(initialTurn(), OFF_FOR_TAB) : initialTurn();
      this.log = []; // [{ key, you, turn }]: turn is the ThreadTurn of a restored exchange, null for the live one
      this.ask = null; // { message, clientTurnId, threadId } of the live exchange, reused by retry()
      this.run = null; // { controller, lastSeq, started, done } of the request in flight
      this.loading = null; // AbortController of GET /apps/olivia/thread
      this.cooldownTimer = 0;
      this.invalidFrames = 0;
      this.replyReady = false;
      this.forceBottom = false;
      this.announced = '';
      this.inerted = new Set();
      this.bodyWatch = null;
      this.articles = new Map(); // entry key -> { article, you, ans, card, actions, wait, cards, actionsKey, settled }
      this.transcript = this.querySelector('.olivia-panel__transcript');
      this.bottom = this.querySelector('.olivia-panel__bottom');
      this.status = this.querySelector('.olivia-panel__status');
      this.composer = this.querySelector('.olivia-composer');
      this.input = this.querySelector('#olivia-c');
      animateInputHint(this.input, this, signal);
      this.sendButton = this.querySelector('.olivia-composer__send');
      this.wide = window.matchMedia(PANEL_WIDE_QUERY);
      this.measure ??= meterPanel(this);
      this.querySelector('.olivia-panel__reduce').addEventListener('click', () => this.reduce(), { signal });
      this.querySelector('.olivia-panel__new').addEventListener('click', () => this.newConversation(), { signal });
      this.querySelector('.olivia-panel__close').addEventListener('click', () => this.close(), { signal });
      this.bottom.addEventListener('click', () => this.toBottom(), { signal });
      this.composer.addEventListener('submit', (event) => this.onSubmit(event), { signal });
      this.composer.addEventListener('click', () => {
        if (this.expand()) focusOlivia(this.input);
      }, { signal });
      this.input.addEventListener('focus', () => this.expand(), { signal });
      this.transcript.addEventListener('scroll', () => this.paintBottom(), { signal, passive: true });
      this.wide.addEventListener('change', () => this.render(), { signal });
      document.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      this.listenSignals(signal);
      this.render();
    }

    disconnectedCallback() {
      this.listeners.abort();
      this.abortRun();
      this.loading?.abort();
      this.loading = null;
      window.clearTimeout(this.cooldownTimer);
      this.cooldownTimer = 0;
      this.paintInert(false);
    }

    // ── public: what the bar, the buttons and the keyboard ask for ───────────────────────────────

    /** Sends a question: from the bar (the first send opens the panel) or from the composer. False when the
        text is empty or too long, the phase takes no question, or the panel is not where one is asked
        (Riprendi first from the resume bar; the docked composer opens on focus). `intent` names the suggestion the
        visitor tapped (spec 13.15); a typed question has none. */
    send(message, intent) {
      const text = typeof message === 'string' ? message.trim() : '';
      if (text === '' || text.length > MESSAGE_MAX || !turnTraits(this.view.phase).canSend) return false;
      const first = this.panel === 'bar_new';
      if (!first && this.panel !== 'open') return false;
      this.ask = Object.freeze({ message: text, clientTurnId: crypto.randomUUID(), threadId: this.keepThread(), intent: INTENT_IDS.includes(intent) ? intent : undefined });
      if (first) this.panel = reducePanel(this.panel, { kind: 'send' });
      this.log = [...this.log, Object.freeze({ key: this.ask.clientTurnId, you: text, turn: null })];
      this.forceBottom = true;
      this.step({ kind: 'submit' });
      this.change(first ? 'first_send' : 'turn', () => {
        this.render();
        if (first) focusOlivia(this.input);
      });
      this.startRun(this.ask).catch((error) => console.error('[olivia] run failed', error));
      return true;
    }

    /** Re-POSTs the live question with the same clientTurnId (spec 4.5: the server replays or resumes). */
    retry() {
      if (this.view.phase !== 'error' || this.ask === null) return false;
      this.step({ kind: 'retry' });
      if (this.view.phase !== 'sending') return false;
      this.keepThread();
      this.forceBottom = true;
      this.change(null, () => {
        this.render();
        focusOlivia(this.input);
      });
      this.startRun(this.ask).catch((error) => console.error('[olivia] run failed', error));
      return true;
    }

    /** "Riprendi la conversazione": one GET /apps/olivia/thread for the stored thread, then the panel opens on
        the transcript, or on the reason it could not be read (fromHttp, as for a run). */
    async resume() {
      if (this.panel !== 'bar_resume' || this.threadId === null || !turnTraits(this.view.phase).canResume) return false;
      const threadId = this.threadId;
      const controller = new AbortController();
      this.panel = reducePanel(this.panel, { kind: 'resume' });
      this.loading = controller;
      this.render();
      let response = null;
      let failure = null;
      try {
        response = await fetchThread(threadId, controller.signal, globalThis.fetch, THREAD_TIMEOUT_MS, this.sessionToken);
      } catch (error) {
        failure = error;
      }
      if (this.loading !== controller) return false; // Chiudi or Escape while the transcript was read
      this.loading = null;
      if (response !== null) {
        this.log = restoredEntries(response);
        this.ask = null;
        if (takesNew(this.view.phase)) this.step({ kind: 'new' });
        this.panel = reducePanel(this.panel, { kind: 'loaded' });
      } else {
        const previous = this.view;
        this.commit(previous, fromHttp(previous, toHttpInput(failure) ?? ABORTED), null);
        this.panel = reducePanel(this.panel, { kind: 'load_failed' });
      }
      this.forceBottom = true;
      this.change('resume', () => {
        this.render();
        focusOlivia(this.input);
      });
      return true;
    }

    /** Riduci: the composer alone, docked; the run in flight goes on (C5). */
    reduce() {
      if (this.panel !== 'open') return false;
      this.panel = reducePanel(this.panel, { kind: 'reduce' });
      this.change('reduce', () => {
        this.render();
        focusOlivia(this.composer);
      });
      return true;
    }

    /** The docked composer opens again (a tap on it or a focus on its input). The transcript stays
        where the visitor left it (plan C Task 11), unless a reply arrived while docked: then it shows it. */
    expand() {
      if (this.panel !== 'docked') return false;
      this.panel = reducePanel(this.panel, { kind: 'expand' });
      this.forceBottom = this.replyReady;
      this.replyReady = false;
      this.change('expand', () => this.render());
      return true;
    }

    /** Nuova conversazione: aborts the run, forgets the thread (C6) and empties the transcript. */
    newConversation() {
      if (this.panel !== 'open') return false;
      this.stopWork();
      if (this.local !== null) clearStoredThread(this.local);
      this.threadId = null;
      this.sessionToken = null;
      this.expiredThread = false;
      this.ask = null;
      this.log = [];
      this.replyReady = false;
      if (takesNew(this.view.phase)) this.step({ kind: 'new' });
      this.panel = reducePanel(this.panel, { kind: 'new' });
      this.change('new', () => {
        this.render();
        focusOlivia(this.input);
      });
      return true;
    }

    /** Chiudi or Escape: aborts the run or the transcript read; the bar comes back, as "Riprendi la
        conversazione" while a thread is kept, and takes the focus. */
    close() {
      const next = reducePanel(this.panel, { kind: 'close', hasThread: false });
      if (next === this.panel) return false;
      this.stopWork();
      // Chiudi ends the conversation (owner, 2026-10-08: "once you closed you closed"): the stored id goes, the next send opens a new thread
      if (this.local !== null) clearStoredThread(this.local);
      this.threadId = null;
      this.sessionToken = null;
      this.panel = next;
      this.replyReady = false;
      this.change('close', () => {
        this.render();
        const field = document.getElementById('olivia-q');
        if (field instanceof HTMLInputElement) field.value = ''; // the closed question does not linger in the bar
        this.focusBar();
      });
      return true;
    }

    // ── state ─────────────────────────────────────────────────────────────────────────────────────

    /** The thread of a voluntary send (C6): the stored or in-page id, else a new one; every send writes it
        only after the server issues a signed 15-day capability. An expired entry is removed first. */
    keepThread() {
      if (this.expiredThread) {
        if (this.local !== null) clearStoredThread(this.local);
        this.expiredThread = false;
      }
      this.threadId ??= crypto.randomUUID();
      // Store only after the server has issued a capability, never a provisional client id.
      return this.threadId;
    }

    abortRun() {
      const run = this.run;
      this.run = null;
      run?.controller.abort();
    }

    /** Chiudi and Nuova conversazione stop what is in flight: the transcript read, and the run (`abort`). */
    stopWork() {
      if (this.loading !== null) {
        const loading = this.loading;
        this.loading = null;
        loading.abort();
      }
      if (turnTraits(this.view.phase).running) {
        this.abortRun();
        this.step({ kind: 'abort' });
      }
    }

    /** One reduceTurn step without painting; returns the view before it. */
    step(input) {
      const previous = this.view;
      const next = reduceTurn(previous, input);
      if (next.unknownEvents > previous.unknownEvents) console.warn(`[olivia] ignored ${turnInputKey(input)} in ${previous.phase}`);
      this.commit(previous, next, input);
      return previous;
    }

    /** Takes a new turn view: analytics (input null = the transcript read, not measured), Risposta pronta, timers. */
    commit(previous, next, input) {
      this.view = next;
      if (input !== null) this.measure(this.ask?.clientTurnId ?? '', previous, input, next);
      if (this.panel === 'docked' && turnTraits(previous.phase).running && !turnTraits(next.phase).running) this.replyReady = true;
      if (next.phase !== previous.phase) this.enterPhase(previous.phase, next);
    }

    /** A run event or a timer: one step, then a paint; the reply rises in (`answer`) when it first shows. */
    dispatch(input) {
      const previous = this.step(input);
      const appears = this.hasLive() && !replyVisible(previous) && replyVisible(this.view);
      this.change(appears ? 'answer' : null, () => this.render());
    }

    enterPhase(from, view) {
      if (from === 'cooldown') {
        window.clearTimeout(this.cooldownTimer);
        this.cooldownTimer = 0;
      }
      if (view.phase === 'cooldown') {
        const seconds = Math.max(1, view.retryAfterSec ?? DEFAULT_COOLDOWN_SEC);
        this.cooldownTimer = window.setTimeout(() => {
          this.cooldownTimer = 0;
          this.dispatch({ kind: 'timer' });
        }, seconds * 1000);
      }
      if (view.phase === 'off') writeOff(this.session);
    }

    hasLive() {
      const last = this.log.at(-1);
      return last !== undefined && last.turn === null;
    }

    async startRun(ask) {
      this.abortRun();
      const run = { controller: new AbortController(), lastSeq: -1, started: false, done: false };
      this.run = run;
      const data = document.querySelector('lab-olivia-bar')?.dataset ?? {};
      try {
        let capability;
        try { capability = await obtainSession(this.sessionToken, run.controller.signal); }
        catch (error) {
          if (!this.sessionToken || error.status !== 403 || error.code !== 'INVALID_INPUT' || this.run !== run) throw error;
          // An expired or revoked capability cannot recover an old transcript. Start fresh once.
          this.sessionToken = null;
          if (this.local !== null) clearStoredThread(this.local);
          if (this.layout === 'band') {
            // Advice from a revoked capability must not acquire actions scoped to a new thread.
            this.log = this.log.filter(entry => entry.key === ask.clientTurnId);
            this.needsRestore = false;
            this.paintTranscript();
          }
          capability = await obtainSession(null, run.controller.signal);
        }
        if (this.run !== run) return;
        this.threadId = capability.threadId;
        this.sessionToken = capability.token;
        if (this.local !== null) storeThread(this.local, capability.threadId, Date.now(), capability);
        this.analyticsContext = await captureAnalyticsContext();
        if (this.run !== run) return;
        const originalAsk = ask;
        ask = Object.freeze({ ...ask, threadId: capability.threadId });
        if (this.ask === originalAsk) this.ask = ask;
        const request = buildRunRequest({
          threadId: ask.threadId,
          clientTurnId: ask.clientTurnId,
          locale: mapLocale(data.locale ?? ''),
          country: data.country ?? '',
          currency: data.currency ?? '',
          template: data.page ?? '',
          handle: data.handle,
          message: ask.message,
          intent: ask.intent,
          testSecret: data.testSecret,
        });
        // openSSE adds the CLIENT_TIMEOUT_MS deadline itself: the panel passes only the visitor's abort.
        for await (const frame of openSSE(ENDPOINTS.run, JSON.stringify(request), run.controller.signal, globalThis.fetch, CLIENT_TIMEOUT_MS, this.sessionToken, this.analyticsContext)) {
          if (this.run !== run) return;
          const event = parseEvent(frame);
          if (event === undefined) {
            this.invalidFrames += 1;
            continue;
          }
          run.lastSeq = Math.max(run.lastSeq, event.seq);
          if (event.type === 'RUN_STARTED') { run.started = true; run.id = event.runId; }
          if (event.type === 'RUN_FINISHED' || event.type === 'RUN_ERROR') run.done = true;
          this.dispatch(event);
        }
        if (this.run === run && !run.done) this.dispatch(streamEnded(run, 'ABORTED'));
      } catch (error) {
        if (this.run !== run) return; // Chiudi, Escape or Nuova conversazione already moved the turn
        const input = toHttpInput(error) ?? ABORTED;
        this.dispatch(run.started ? streamEnded(run, input.code === 'TIMEOUT' ? 'TIMEOUT' : 'ABORTED') : input);
      } finally {
        if (run.started && run.id && this.run === run && analyticsAllowed()) {
          const context = analyticsFromCookies(document.cookie, true) ?? this.analyticsContext;
          void sendAnalyticsResult({ threadId: ask.threadId, runId: run.id, token: this.sessionToken, context });
        }
        if (this.run === run) this.run = null;
      }
    }

    // ── paint ─────────────────────────────────────────────────────────────────────────────────────

    /** The layout of this surface, the key of its TRANSITIONS table. */
    get layout() {
      return 'panel';
    }

    /** The seam of the in-page transitions (spec 13.3, C13): every paint goes through runTransition(host,
        layout, kind, paint). kind is first_send, turn, answer, resume, expand, reduce, close, new, or null for
        an instant change. The state is already updated when this runs; paint (render, then the focus of 13.1)
        runs inside the transition's update, after the old state was captured, so the focus lands on the new one. */
    change(kind, paint) {
      runTransition(this, this.layout, kind, paint);
    }

    render() {
      // a display: none transcript (docked) measures 0 × 0 and would count as at its bottom: the
      // openings that want the end (send, retry, resume, a reply arrived docked) set forceBottom
      const stick = this.forceBottom || (this.transcript.clientHeight > 0 && this.atBottom());
      this.forceBottom = false;
      const surface = panelTraits(this.panel);
      const turn = turnTraits(this.view.phase);
      this.hidden = !surface.panel;
      this.dataset.panel = this.panel;
      this.dataset.state = this.view.phase;
      this.dataset.surface = surface.surface;
      this.dataset.busy = String(this.view.busy);
      this.paintRole();
      this.paintTranscript();
      this.sendButton.disabled = !turn.canSend;
      this.input.disabled = !turn.input;
      this.paintStatus(surface);
      if (stick && surface.panel && surface.surface === 'open') this.scrollToEnd();
      this.paintBottom();
      this.announce();
    }

    /** role per width (C12); on the phone, while open, the page around the sheet is inert. */
    paintRole() {
      const wide = this.wide.matches;
      this.setAttribute('role', panelRole(wide));
      const trap = trapsFocus(this.panel, wide);
      if (trap) this.setAttribute('aria-modal', 'true');
      else this.removeAttribute('aria-modal');
      this.paintInert(trap);
    }

    /** Every child of <body> but the panel and the consent dialog; children added later (an app embed) are
        made inert as they arrive. Only what this panel made inert is released. */
    paintInert(on) {
      if (on) {
        for (const element of document.body.children) {
          if (element === this || element.inert || element.matches(NOT_PAGE) || holdsConsent(element) || element.matches(FORMS_HOST) || element.querySelector(FORMS_HOST)) continue;
          element.inert = true;
          this.inerted.add(element);
        }
        if (this.bodyWatch === null) {
          this.bodyWatch = new MutationObserver(() => this.paintInert(trapsFocus(this.panel, this.wide.matches)));
          this.bodyWatch.observe(document.body, { childList: true });
        }
        return;
      }
      this.bodyWatch?.disconnect();
      this.bodyWatch = null;
      for (const element of this.inerted) element.inert = false;
      this.inerted.clear();
    }

    /** One article.olivia-turn per log entry, in log order; a restored entry is painted once, a former live
        one is settled once, the live one follows the turn view. */
    paintTranscript() {
      const keys = new Set(this.log.map((entry) => entry.key));
      for (const [key, parts] of this.articles) {
        if (keys.has(key)) continue;
        parts.article.remove();
        this.articles.delete(key);
      }
      const last = this.log.at(-1);
      for (const entry of this.log) {
        let parts = this.articles.get(entry.key);
        if (parts === undefined) {
          parts = this.article(entry);
          this.transcript.append(parts.article);
          this.articles.set(entry.key, parts);
        }
        if (entry.turn !== null || parts.settled) continue;
        if (entry === last) this.paintLive(parts);
        else this.settle(parts);
      }
    }

    article(entry) {
      const article = cardNode('article', 'olivia-turn');
      article.dataset.turnKey = entry.key;
      if (entry.turn !== null) article.dataset.runId = entry.turn.runId; // Task 13: the actions row of an old limit has no card slot to carry it
      const you = cardNode('p', 'olivia-turn__you', entry.you);
      const reply = cardNode('div', 'olivia-turn__reply');
      const ans = cardNode('div', 'olivia-turn__ans');
      const card = cardNode('div', 'olivia-turn__card');
      const actions = cardNode('div', 'olivia-turn__actions');
      const suggest = cardNode('div', 'olivia-turn__suggest');
      card.hidden = true;
      actions.hidden = true;
      suggest.hidden = true;
      reply.append(ans, card, actions, suggest);
      article.append(you, reply);
      const parts = { article, you, ans, card, actions, suggest, wait: null, cards: null, actionsKey: null, pills: NO_SUGGESTIONS, settled: false };
      if (entry.turn === null) {
        // the live answer is the one live region of the transcript; a restored one is never announced
        ans.setAttribute('aria-live', 'polite');
        ans.setAttribute('aria-atomic', 'false');
      } else {
        this.paintReply(parts, entry.turn.answer, entry.turn.cards, entry.turn.runId, limitNote(entry.turn.limitReason), false);
        parts.settled = true;
      }
      return parts;
    }

    paintLive(parts) {
      const view = this.view;
      if (view.runId !== undefined && view.runId !== null) parts.article.dataset.runId = view.runId; // Task 13: an error or limit row has no card slot to carry it
      const { running } = turnTraits(view.phase);
      parts.ans.setAttribute('aria-busy', String(running));
      // D18: the wait line stands in until the first delta, and again after a retract empties the text
      this.paintWait(parts, running && view.text === '');
      if (running) {
        // the live text grows delta by delta; card, note and actions come with the end of the run (a retry starts over)
        this.paintReply(parts, view.text, NO_CARDS, '', replyNote(view), true);
        this.paintSuggestions(parts, NO_SUGGESTIONS);
        return;
      }
      if (!replyVisible(view)) return; // idle: the run was stopped or a cooldown ran out; the exchange keeps what it showed
      this.paintReply(parts, view.text, view.cards, view.runId ?? '', replyNote(view), true);
      // spec 13.15: the suggestions of olivia.end, under the newest answer only, once the run is done
      this.paintSuggestions(parts, view.phase === 'done' ? view.suggestions : NO_SUGGESTIONS);
    }

    /** A former live exchange: no live region, no wait line, no Riprova; its note, card and links stay. */
    settle(parts) {
      for (const name of ['aria-live', 'aria-atomic', 'aria-busy']) parts.ans.removeAttribute(name);
      this.paintWait(parts, false);
      for (const button of parts.actions.querySelectorAll('button')) button.remove();
      parts.actions.hidden = parts.actions.childElementCount === 0;
      // spec 13.15: the suggestions stand under the newest answer only; anything the visitor sends takes them away
      this.paintSuggestions(parts, NO_SUGGESTIONS);
      parts.settled = true;
    }

    paintWait(parts, on) {
      if (on && parts.wait === null) {
        parts.wait = cardNode('p', 'olivia-turn__wait', oliviaStrings().thinking);
        parts.you.after(parts.wait);
      } else if (!on && parts.wait !== null) {
        parts.wait.remove();
        parts.wait = null;
      }
    }

    paintReply(parts, text, cards, runId, rule, live) {
      const current = parts.ans.textContent;
      // D18: a delta is appended as a text node, so the live region reads only what is new; a retract, a claim trip
      // or a retry replaces the whole text
      if (current !== text) {
        if (current !== '' && text.startsWith(current)) parts.ans.append(text.slice(current.length));
        else parts.ans.textContent = text;
      }
      this.paintCard(parts, cards, runId);
      this.paintActions(parts, rule, live);
    }

    /** The last valid card of the run (spec 7.3), inline after the answer, painted again only when the
        run's card list changes; the card root carries data-run-id (C12, read by the signals of Task 13). */
    paintCard(parts, cards, runId) {
      if (parts.cards === cards) return;
      parts.cards = cards;
      const pick = cards.length === 0 ? null : lastValidCard(cards);
      parts.card.replaceChildren();
      parts.card.hidden = true;
      parts.card.dataset.kind = pick === null ? '' : pick.type;
      parts.card.dataset.cardId = pick === null ? '' : pick.id;
      if (pick === null) return;
      try {
        const fragment = renderCard(pick, this.cardContext());
        fragment.firstElementChild?.setAttribute('data-run-id', runId);
        parts.card.replaceChildren(fragment);
        parts.card.hidden = false;
      } catch (error) {
        console.warn('[olivia] card not rendered; the answer stays', pick.type, error);
        parts.card.replaceChildren();
      }
    }

    paintActions(parts, rule, live) {
      const retry = live && rule.retry === 'retry' && this.ask !== null;
      const reload = live && rule.retry === 'reload';
      const fresh = live && rule.newConversation;
      const key = `${rule.note}|${retry}|${reload}|${fresh}|${rule.contact}`;
      if (parts.actionsKey === key) return;
      parts.actionsKey = key;
      const strings = oliviaStrings();
      const nodes = [];
      if (rule.note !== '') nodes.push(cardNode('p', 'olivia-turn__note', strings[rule.note]));
      if (retry) nodes.push(this.actionButton('olivia-turn__retry', strings.retry, () => this.retry()));
      if (reload) nodes.push(this.actionButton('olivia-turn__reload', strings.reload, () => window.location.reload()));
      if (fresh) nodes.push(this.actionButton('olivia-turn__new', strings.new_conversation, () => this.newConversation()));
      if (rule.contact) {
        const link = cardLink(strings.contact, this.contactHref());
        link.classList.add('olivia-turn__contact');
        nodes.push(link);
      }
      parts.actions.replaceChildren(...nodes);
      parts.actions.hidden = nodes.length === 0;
    }

    /** Spec 13.15: up to SUGGESTIONS_MAX buttons under the newest answer; a tap sends the suggestion's text with its
        intent. Painted again only when the list changes; settle() takes them away. */
    paintSuggestions(parts, suggestions) {
      if (parts.pills === suggestions) return;
      parts.pills = suggestions;
      const buttons = suggestions.slice(0, SUGGESTIONS_MAX).map((suggestion) => {
        const button = cardNode('button', 'olivia-turn__pill', suggestion.label);
        button.type = 'button';
        button.dataset.intent = suggestion.intent;
        button.addEventListener('click', () => this.send(suggestion.send, suggestion.intent));
        return button;
      });
      parts.suggest.replaceChildren(...buttons);
      parts.suggest.hidden = buttons.length === 0;
    }

    actionButton(className, label, onClick) {
      const button = cardNode('button', `btn ${className}`, label);
      button.type = 'button';
      button.addEventListener('click', onClick);
      return button;
    }

    /** "Risposta pronta" on the docked composer; on an open panel without a live exchange the note of the
        phase (a resume that failed, an off runtime, a cooldown). */
    paintStatus(surface) {
      let key = '';
      if (this.panel === 'docked' && this.replyReady) key = 'reply_ready';
      else if (surface.panel && !this.hasLive()) key = standingNote(this.view.phase);
      const text = key === '' ? '' : oliviaStrings()[key];
      if (this.status.textContent !== text) this.status.textContent = text;
      this.status.hidden = text === '';
    }

    atBottom() {
      const { scrollTop, scrollHeight, clientHeight } = this.transcript;
      return nearBottom({ scrollTop, scrollHeight, clientHeight });
    }

    scrollToEnd() {
      this.transcript.scrollTop = this.transcript.scrollHeight;
    }

    /** "Vai in fondo" while the open transcript sits more than 24 px above its end. */
    paintBottom() {
      const surface = panelTraits(this.panel);
      this.bottom.hidden = !(surface.panel && surface.surface === 'open') || this.atBottom();
    }

    toBottom() {
      this.scrollToEnd();
      this.paintBottom();
      focusOlivia(this.input);
    }

    /** olivia:phase ({ panel, phase }, bubbles) at every change of either machine: the bar mirrors it. */
    announce() {
      const key = `${this.panel}|${this.view.phase}`;
      if (key === this.announced) return;
      this.announced = key;
      this.dispatchEvent(new CustomEvent('olivia:phase', { bubbles: true, detail: { panel: this.panel, phase: this.view.phase } }));
    }

    focusBar() {
      const target = panelTraits(this.panel).bar === 'resume'
        ? document.querySelector('lab-olivia-bar .olivia-bar__resume')
        : document.getElementById('olivia-q');
      focusOlivia(target);
    }

    /** The card context renderCard reads (spec 7.3): the panel's strings and data attributes. */
    cardContext() {
      const { moneyFormat, root, cartAdd, contactUrl, checkoutUrl } = this.dataset;
      return {
        strings: oliviaStrings(), moneyFormat, root, cartAdd, contactUrl, checkoutUrl, lang: document.documentElement.lang || 'it',
        signal: (kind, control) => this.signalAfter(kind, control),
        attribute: async (control, lines) => {
          const scope = signalScope(control, () => this.threadId && this.sessionToken ? { id: this.threadId } : null);
          return scope.ok ? attributeCart({ ...scope, token: this.sessionToken, root, variants: lines.map(line => line.variantId) }) : false;
        },
      };
    }

    // ── signals after a visible action (Task 13; spec 13.6, C7) ─────────────────────────────
    /** One beacon for the life of the element (the once-per-answer set survives a reconnect), one click
        listener on the exchange holder (the panel's transcript, the band's exchange) for every card and
        actions row the surface will hold. */
    listenSignals(signal) {
      this.beacon ??= new SignalBeacon((request) => sendSignal({ ...request, token: this.sessionToken, analytics: analyticsAllowed() ? (analyticsFromCookies(document.cookie, true) ?? this.analyticsContext) : null }));
      this.transcript.addEventListener('click', (event) => this.onTranscriptClick(event), { signal });
    }

    /** The contact page every contact link of the surface points to (contact_row and the actions row). */
    contactHref() {
      return this.dataset.contactUrl || '/pages/contact';
    }

    /** The click listener: links in cards and in an exchange's actions row. Buttons never signal here;
        the cart button signals from the cart path (cardAddToCart). */
    onTranscriptClick(event) {
      const control = event.target instanceof Element ? event.target.closest('a[href], button') : null;
      if (control === null || !event.currentTarget.contains(control)) return;
      const cardRoot = control.closest('.olivia-card');
      if (cardRoot === null && control.closest('.olivia-turn__actions') === null) return;
      const card = cardRoot === null ? null : cardValueOf(cardRoot);
      if (cardRoot !== null && card === null) {
        console.warn('[olivia] click on a card renderCard did not build; no signal', cardRoot.dataset.card);
        return;
      }
      const link = control instanceof HTMLAnchorElement;
      const href = link ? clickedPath(control.getAttribute('href') ?? '', location.origin) : ''; // the GA linker's absolute ?_gl= href reads as its path
      const kind = signalFor(link ? { tag: 'a', href, contact: href === this.contactHref() } : { tag: 'button' }, card);
      if (kind !== null) this.signalAfter(kind, control);
    }

    /** The one way out of the surface for a signal (the click listener, and ctx.signal of the cart
        path): ids from the DOM and the stored thread, then the beacon. */
    signalAfter(kind, control) {
      const scope = signalScope(control, () => this.threadId && this.sessionToken ? { id: this.threadId } : null);
      if (!scope.ok) {
        // an actions row of an exchange that failed before RUN_STARTED has no run: nothing to send, nothing to report
        const expected = scope.reason === 'no_run' && control.closest('.olivia-card') === null;
        if (!expected) console.warn(`[olivia] signal ${kind} not sent: ${scope.reason}`);
        return false;
      }
      return this.beacon.record(kind, scope);
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.send(this.input.value)) this.input.value = '';
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;
      // Shadow events are retargeted to the Forms host; keep Escape with its popup even if
      // Forms has already removed the dialog earlier in the same event dispatch.
      if (formsModalOpen() || event.composedPath().some((node) => node instanceof Element && node.matches(FORMS_HOST))) return;
      if (document.querySelector('dialog[open]') || document.querySelector('lab-header')?.isOpen?.()) return;
      if (event.target instanceof Element && event.target.closest('dialog, #lab-unfold, #cookie-consent-banner') !== null) return;
      if (this.close()) event.preventDefault();
    }
  }

  /* The website answers in a full-width theme section below its persistent input.
     Only the current exchange is presented; the server keeps context for follow-up questions.
     Showing an answer after navigation reads the authenticated history without inference. */
  class LabOliviaBand extends LabOliviaPanel {
    connectedCallback() {
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      this.local = storageOf('localStorage');
      this.session = storageOf('sessionStorage');
      const stored = this.local === null ? null : readStoredThread(this.local, Date.now());
      this.threadId = stored?.token ? stored.id : null;
      this.sessionToken = stored?.token ?? null;
      this.expiredThread = stored !== null && 'expired' in stored;
      this.needsRestore = this.threadId !== null;
      this.panel = initialBand(this.needsRestore);
      this.view = initialTurn();
      this.log = [];
      this.ask = null;
      this.run = null;
      this.loading = null;
      this.pendingAsk = null;
      this.restoreNote = '';
      this.cooldownTimer = 0;
      this.invalidFrames = 0;
      this.replyReady = false;
      this.forceBottom = false;
      this.announced = '';
      this.articles = new Map();
      this.transcript = this.querySelector('.olivia-band__exchange');
      this.reader = this.querySelector('.olivia-band__body');
      this.status = this.querySelector('.olivia-band__status');
      this.composer = document.querySelector('.olivia-bar__form');
      this.input = document.getElementById('olivia-q');
      this.sendButton = document.querySelector('.olivia-bar__send');
      this.keyboardInteraction = true;
      this.measure ??= meterPanel(this);
      this.restoreButton = this.actionButton('olivia-band__restore', oliviaStrings().retry, () => {
        if (restoreTraits(this.view).reload) window.location.reload();
        else this.resume().catch((error) => console.error('[olivia] resume failed', error));
      });
      this.restoreButton.hidden = true;
      this.status.after(this.restoreButton);
      this.querySelector('.olivia-band__close').addEventListener('click', (event) => {
        this.keyboardInteraction = event.detail === 0;
        const dock = document.querySelector('lab-olivia-dock');
        if (dock?.canCollapse) dock.setCollapsed(true, 'manual');
        else this.reduce(true);
      }, { signal });
      document.addEventListener('keydown', (event) => {
        this.keyboardInteraction = true;
        this.onKeydown(event);
      }, { signal });
      document.addEventListener('pointerdown', () => {
        this.keyboardInteraction = false;
      }, { signal });
      document.addEventListener('click', (event) => {
        // A site section stays open while browsing. Give explicit navigation overlays
        // their space before their own click handlers run, including the mobile strip.
        if (!formsModalOpen() && event.target instanceof Element &&
            event.target.closest('[data-lab-unfold], [data-strip-cart], #cart-icon-bubble')) this.reduce(false);
      }, { capture: true, signal });
      window.addEventListener('pagehide', () => {
        // A bfcache return should expose the same reversible entry as a normal navigation.
        if (this.panel === 'open') this.reduce(false);
      }, { signal });
      window.addEventListener('pageshow', () => this.render(), { signal });
      this.listenSignals(signal);
      this.render();
    }

    disconnectedCallback() {
      this.listeners.abort();
      this.abortRun();
      this.loading?.abort();
      this.loading = null;
      window.clearTimeout(this.cooldownTimer);
      this.motion?.cancel();
    }

    send(message, intent) {
      const text = typeof message === 'string' ? message.trim() : '';
      if (text === '' || text.length > MESSAGE_MAX || !turnTraits(this.view.phase).canSend || this.loading) return false;
      if (this.needsRestore) {
        if (!this.canRestore()) return false;
        this.resume({ message: text, intent }).catch((error) => console.error('[olivia] resume failed', error));
        return true;
      }
      const first = this.panel !== 'open';
      this.restoreNote = '';
      this.ask = Object.freeze({ message: text, clientTurnId: crypto.randomUUID(), threadId: this.keepThread(), intent: INTENT_IDS.includes(intent) ? intent : undefined });
      this.panel = reduceBand(this.panel, { kind: 'send' });
      this.log = [Object.freeze({ key: this.ask.clientTurnId, you: text, turn: null })];
      this.forceBottom = true;
      this.step({ kind: 'submit' });
      this.change(first ? 'first_send' : null, () => {
        this.render();
        focusOlivia(this.input, { preventScroll: true });
      });
      this.startRun(this.ask).catch((error) => console.error('[olivia] run failed', error));
      return true;
    }

    canRestore() {
      return this.needsRestore && this.threadId !== null && this.loading === null && restoreTraits(this.view).retry;
    }

    async resume(pending = null) {
      // A hidden error remains readable even when its recovery action is wait or reload.
      if (this.panel === 'docked' && (!this.needsRestore || !restoreTraits(this.view).retry)) return this.expand();
      if (!this.canRestore()) return false;
      const threadId = this.threadId;
      const controller = new AbortController();
      this.pendingAsk = pending;
      this.loading = controller;
      this.panel = 'resuming';
      this.restoreNote = '';
      this.change('resume', () => this.render());
      let response = null;
      let failure = null;
      try {
        response = await fetchThread(threadId, controller.signal, globalThis.fetch, THREAD_TIMEOUT_MS, this.sessionToken);
      } catch (error) {
        failure = error;
      }
      if (this.loading !== controller) return false;
      this.loading = null;
      const queued = this.pendingAsk;
      this.pendingAsk = null;
      this.panel = reduceBand(this.panel, { kind: response ? 'loaded' : 'load_failed' });
      const missingHistory = response !== null && response.turns.length === 0;
      if (response && !missingHistory) {
        this.log = restoredEntries(response).slice(-1);
        this.ask = null;
        this.needsRestore = false;
        if (takesNew(this.view.phase)) this.step({ kind: 'new' });
        this.forceBottom = true;
        this.render();
        if (queued) this.send(queued.message, queued.intent);
        else focusOlivia(this.reader, { preventScroll: true });
      } else {
        const expired = missingHistory || failure?.status === 401 || failure?.status === 404 ||
          (failure?.status === 403 && failure?.code !== 'RUNTIME_OFF');
        if (expired) {
          if (this.local !== null) clearStoredThread(this.local);
          this.threadId = null;
          this.sessionToken = null;
          this.needsRestore = false;
          this.expiredThread = false;
          this.restoreNote = oliviaStrings().conversation_expired;
          this.log = [];
          this.ask = null;
          this.commit(this.view, initialTurn(), null);
        } else {
          const previous = this.view;
          this.commit(previous, fromHttp(previous, toHttpInput(failure) ?? ABORTED), null);
        }
        this.render();
        // A failed read never silently loses a question or sends against incomplete history.
        if (queued) {
          this.input.value = queued.message;
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      return true;
    }

    reduce(focus = false) {
      if (this.panel !== 'open' && this.panel !== 'resuming') return false;
      if (this.loading) {
        const loading = this.loading;
        this.loading = null;
        loading.abort();
        if (this.pendingAsk) this.input.value = this.pendingAsk.message;
        this.pendingAsk = null;
      }
      this.panel = reduceBand(this.panel, { kind: 'reduce' });
      this.change('reduce', () => this.render());
      if (focus) {
        const button = document.querySelector('.olivia-bar__resume');
        if (button && !button.hidden) focusOlivia(button, { preventScroll: true });
        else this.focusBar();
      }
      return true;
    }

    expand() {
      if (this.panel !== 'docked') return false;
      this.panel = reduceBand(this.panel, { kind: 'expand' });
      this.forceBottom = this.replyReady;
      this.replyReady = false;
      this.change('expand', () => this.render());
      focusOlivia(this.reader, { preventScroll: true });
      return true;
    }

    newConversation() {
      return this.close();
    }

    close() {
      if (!['open', 'docked', 'resuming'].includes(this.panel)) return false;
      this.stopWork();
      if (this.local !== null) clearStoredThread(this.local);
      this.threadId = null;
      this.sessionToken = null;
      this.needsRestore = false;
      this.expiredThread = false;
      this.pendingAsk = null;
      this.restoreNote = '';
      this.ask = null;
      this.log = [];
      this.replyReady = false;
      if (takesNew(this.view.phase)) this.step({ kind: 'new' });
      this.panel = reduceBand(this.panel, { kind: 'close', hasThread: false });
      this.input.value = '';
      this.change('close', () => this.render());
      this.focusBar();
      return true;
    }

    get layout() { return 'band'; }

    entryAvailable() {
      return !formsModalOpen() && !document.querySelector('dialog[open]') &&
        !document.querySelector('lab-header')?.isOpen?.() &&
        !document.documentElement.classList.contains('consent-locked') &&
        !document.body.classList.contains('consent-locked');
    }

    // One paper section continues the sticky composer. A local reveal avoids global
    // View Transition collisions and never animates height or streaming text.
    change(kind, paint) {
      const wasHidden = this.hidden;
      const dock = document.querySelector('lab-olivia-dock');
      paint();
      dock?.syncConversation?.();
      if (this.hidden) {
        this.motion?.cancel();
        return;
      }
      if (wasHidden && ['first_send', 'resume', 'expand'].includes(kind) && !formsModalOpen()) dock?.revealAnswer?.();
      if (!wasHidden || !['first_send', 'resume', 'expand'].includes(kind) ||
          this.keyboardInteraction || matchMedia(MOTION_QUERY.reduced).matches || formsModalOpen()) return;
      this.motion?.cancel();
      this.motion = this.transcript.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 200, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' });
    }

    render() {
      const surface = bandTraits(this.panel);
      const completed = this.dataset.state !== 'done' && this.view.phase === 'done';
      const latest = this.forceBottom;
      this.forceBottom = false;
      this.hidden = !surface.band;
      this.dataset.panel = this.panel;
      this.dataset.state = this.view.phase;
      this.dataset.surface = 'open';
      this.dataset.busy = String(this.view.busy);
      this.paintTranscript();
      if (completed && surface.band && !this.keyboardInteraction && !matchMedia(MOTION_QUERY.reduced).matches && !formsModalOpen()) {
        this.querySelectorAll('.olivia-card').forEach(card => card.animate(
          [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 200, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }));
      }
      this.paintStatus(surface);
      if (latest && surface.band) this.reader.scrollTop = 0;
      this.announce();
      document.querySelector('lab-olivia-dock')?.measure?.();
    }

    paintStatus(surface) {
      const text = this.panel === 'resuming' ? oliviaStrings().thinking : this.restoreNote ||
        (surface.band && !this.hasLive() && standingNote(this.view.phase) ? oliviaStrings()[standingNote(this.view.phase)] : '');
      this.status.textContent = text;
      this.status.hidden = text === '';
      this.restoreButton.hidden = !(this.needsRestore && this.panel === 'open');
      const recovery = restoreTraits(this.view);
      this.restoreButton.textContent = oliviaStrings()[recovery.reload ? 'reload' : 'retry'];
      this.restoreButton.disabled = !recovery.reload && !this.canRestore();
      this.restoreButton.setAttribute('aria-busy', String(this.loading !== null));
    }

    onKeydown(event) {
      if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing) return;
      if (formsModalOpen() || event.composedPath().some((node) => node instanceof Element && node.matches(FORMS_HOST))) return;
      if (document.querySelector('dialog[open]') || document.querySelector('lab-header')?.isOpen?.()) return;
      if (event.target instanceof Element && event.target.closest('dialog, #lab-unfold, #cookie-consent-banner')) return;
      if (this.reduce(true)) event.preventDefault();
    }

    focusBar() {
      const dock = document.querySelector('lab-olivia-dock');
      if (dock) dock.showInput();
      else focusOlivia(this.input, { preventScroll: true });
    }
  }

  class LabOliviaBar extends HTMLElement {
    connectedCallback() {
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      this.field = this.querySelector('.olivia-bar__field');
      this.input = this.querySelector('#olivia-q');
      this.welcome = document.getElementById('olivia-welcome');
      this.composing = false;
      this.input.addEventListener('compositionstart', () => { this.composing = true; }, { signal });
      this.input.addEventListener('compositionend', () => { this.composing = false; }, { signal });
      this.welcome?.querySelectorAll('[data-olivia-starter]').forEach(button => {
        button.addEventListener('click', () => {
          if (this.input.disabled || this.composing || this.panel()?.entryAvailable?.() === false) return;
          // Choosing a starting point prepares a draft; only Send starts a conversation.
          // A visitor's own unfinished question always wins over an example.
          if (this.input.value === '') {
            this.input.value = button.childNodes[0].textContent.trim();
            this.input.dispatchEvent(new Event('input', { bubbles: true }));
          }
          focusOlivia(this.input, { preventScroll: true });
        }, { signal });
      });
      animateInputHint(this.input, this, signal);
      this.sendButton = this.querySelector('.olivia-bar__send');
      this.resumeButton = this.querySelector('.olivia-bar__resume');
      this.status = this.querySelector('.olivia-bar__status');
      this.querySelector('.olivia-bar__form').addEventListener('submit', (event) => this.onSubmit(event), { signal });
      this.resumeButton?.addEventListener('click', () => this.onResume(), { signal });
      this.input.addEventListener('input', () => this.updateSend(), { signal });
      // the layout is read once, at upgrade: band (default) or panel, from settings.olivia_layout
      this.layout = readLayout(this.dataset.layout);
      this.hostId = this.layout === 'band' ? 'olivia-band' : 'olivia-panel';
      document.addEventListener(
        'olivia:phase',
        (event) => {
          if (event.target instanceof Element && event.target.id === this.hostId) this.mirror(event.detail.panel, event.detail.phase);
        },
        { signal },
      );
      const host = document.getElementById(this.hostId);
      this.mirror(host?.dataset.panel, host?.dataset.state);
    }

    disconnectedCallback() {
      this.listeners.abort();
    }

    /** The conversation surface of this layout: #olivia-band or #olivia-panel, once upgraded. */
    panel() {
      const host = document.getElementById(this.hostId);
      if (host === null || typeof host.send !== 'function') {
        console.error(`[olivia] #${this.hostId} is missing or not upgraded`);
        return null;
      }
      return host;
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.panel()?.send(this.input.value)) {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    onResume() {
      this.panel()?.resume().catch((error) => console.error('[olivia] resume failed', error));
    }

    /** The default layout always keeps this composer; the legacy panel still uses its own input.
        A stored or hidden conversation exposes a return action without sending another question. */
    mirror(panelValue, phaseValue) {
      const band = this.layout === 'band';
      const state = (band ? BAND_STATES : PANEL_STATES).includes(panelValue) ? panelValue : 'bar_new';
      const phase = TURN_PHASES.includes(phaseValue) ? phaseValue : 'idle';
      const surface = band ? bandTraits(state) : panelTraits(state);
      const turn = turnTraits(phase);
      this.hidden = band ? false : surface.panel;
      if (this.hidden) this.input.value = ''; // the question now lives in the exchange (Task 12, first_send)
      this.dataset.panel = state;
      this.dataset.state = phase;
      if (this.welcome) {
        this.welcome.hidden = !band || state !== 'bar_new';
        document.documentElement.removeAttribute('data-olivia-returning');
        this.welcome.querySelectorAll('[data-olivia-starter]').forEach(button => {
          button.disabled = !turn.input || surface.busy;
        });
      }
      this.field.hidden = band ? false : surface.bar !== 'new';
      if (this.resumeButton !== null) {
        this.resumeButton.hidden = surface.bar !== 'resume';
        this.resumeButton.disabled = surface.busy || (state !== 'docked' && !turn.canResume);
        this.resumeButton.setAttribute('aria-busy', String(surface.busy));
        this.resumeButton.setAttribute('aria-expanded', String(band ? surface.band : surface.panel && surface.surface === 'open'));
      }
      this.input.disabled = !turn.input || surface.busy;
      this.updateSend();
      const text = turn.status === '' ? '' : oliviaStrings()[turn.status];
      this.status.textContent = text;
      this.status.hidden = text === '';
    }

    updateSend() {
      const phase = TURN_PHASES.includes(this.dataset.state) ? this.dataset.state : 'idle';
      const text = this.input.value.trim();
      const host = this.layout === 'band' ? document.getElementById(this.hostId) : null;
      const restoreBlocked = host?.needsRestore === true && !host.canRestore();
      this.sendButton.disabled = this.input.disabled || !turnTraits(phase).canSend || restoreBlocked || text === '' || text.length > MESSAGE_MAX;
    }
  }

  // Consent withdrawal also removes a private cart marker; no GA identifiers are sent by this cleanup.
  let previousAnalyticsConsent = analyticsAllowed();
  document.addEventListener('visitorConsentCollected', () => {
    const allowed = analyticsAllowed();
    if (previousAnalyticsConsent && !allowed) void clearCartAttribution(globalThis.Shopify?.routes?.root || '/');
    previousAnalyticsConsent = allowed;
  });

  // The surfaces first: the bar reads the data-panel and data-state of its host when it upgrades.
  const defineOlivia = () => {
    if (!customElements.get('lab-olivia-panel')) customElements.define('lab-olivia-panel', LabOliviaPanel);
    if (!customElements.get('lab-olivia-band')) customElements.define('lab-olivia-band', LabOliviaBand);
    if (!customElements.get('lab-olivia-bar')) customElements.define('lab-olivia-bar', LabOliviaBar);
  };
  if (document.prerendering) {
    document.addEventListener('prerenderingchange', defineOlivia, { once: true });
  } else {
    defineOlivia();
  }
}
